<template>
  <div>
    <CRow>
      <CCol sm="12">
        <h1 class="mb-4 font-weight-bold">{{ company_name }}</h1>
      </CCol>
    </CRow>
    <CRow>
      <template v-if="!isSuperOrOrderAdmin">
        <template v-for="order_items_by_status_group_item in order_items_by_status_group">
          <CCol sm="3" :key="order_items_by_status_group_item.id"
                v-if="showDashboardCard(order_items_by_status_group_item.label)">
            <div class="card" style="width: 18rem;" >
              <div class="card-body">
                <h5 class="card-title">{{order_items_by_status_group_item.items_count}}</h5>
                <h5 class="card-title">{{ order_items_by_status_group_item.label }}</h5>
              </div>
            </div>
          </CCol>
        </template>
      </template>
    </CRow>
    <CRow>
      <CCol sm="12">
        <div class="d-flex flex-row-reverse">
          <b-button variant="primary" class="ml-2" @click="openOrderPriceModal" v-if="$can('export-order-prices')">Export Order Prices</b-button>
          <b-button v-if="$can('manual-create-order')" v-b-modal.manual-order-modal variant="primary" class="ml-2">Create Order</b-button>
          <button class="btn btn-primary ml-2" v-if="$can('assign-order-administrator')" @click="showAssignOrderAdminModal">Assign order admin</button>
        </div>
      </CCol>
    </CRow>
    <CRow>

    </CRow>
    <CRow>
      <CCol sm=12>
        <CRow>
          <CCol sm="9">
            <ul class="nav nav-pills mb-3" role="tablist">
              <template v-if="$can('assign-factory-to-shareable-orders')">
                <li class="nav-item"  @click.prevent="switchOrdersTab('pending_for_factory_assignment')" style="cursor:pointer">
                  <a class="nav-link" :class="{'active' : current_Tab === 'pending_for_factory_assignment' }"  role="tab" aria-controls="pills-home"
                     aria-selected="true">Assign Factory
                    <span class="badge badge-light">{{ pending_for_factory_assignment_count}}</span>
                  </a>
                </li>
              </template>
              <li class="nav-item"  @click.prevent="switchOrdersTab('urgent_action_items')" style="cursor:pointer">
                <a class="nav-link" :class="{'active' : current_Tab === 'urgent_action_items' }"  role="tab" aria-controls="pills-home"
                   aria-selected="true">Urgent Action Needed
                  <span class="badge badge-light">{{ urgent_action_items_count}}</span>
                </a>
              </li>
              <li class="nav-item"  @click.prevent="switchOrdersTab('pending_items')" style="cursor:pointer">
                <a class="nav-link" :class="{'active' : current_Tab === 'pending_items' }"  role="tab" aria-controls="pills-home"
                   aria-selected="true">Pending
                  <span class="badge badge-light">{{ pending_items_count}}</span>
                </a>
              </li>
              <li class="nav-item" @click.prevent="switchOrdersTab('customer_await_items')" style="cursor:pointer">
                <a class="nav-link" :class="{'active' : current_Tab === 'customer_await_items' }"   role="tab" aria-controls="pills-profile" aria-selected="false">Waiting for Customer
                  <span class="badge badge-light">{{customer_await_items_count}}</span>
                </a>
              </li>
              <li v-if="$can('show-quotes-tab')" class="nav-item" @click.prevent="switchOrdersTab('quote_requested_items')" style="cursor:pointer">
                <a class="nav-link" :class="{'active' : current_Tab === 'quote_requested_items' }"   role="tab" aria-controls="pills-profile" aria-selected="false">Quote Requested
                  <span class="badge badge-light">{{quote_requested_items_count}}</span>
                </a>
              </li>
              <li class="nav-item" @click.prevent="switchOrdersTab('reorders')" style="cursor:pointer">
                <a class="nav-link"  :class="{'active' : current_Tab === 'reorders' }" role="tab" aria-controls="pills-contact" aria-selected="false">Reorders
                  <span class="badge badge-light">{{ reorders_count }}</span>
                </a>
              </li>
              <li v-if="$can('can-resolve-comment')" class="nav-item" @click.prevent="switchOrdersTab('unresolved_comments')" style="cursor:pointer">
                <a class="nav-link"  :class="{'active' : current_Tab === 'unresolved_comments' }" role="tab" aria-controls="pills-contact" aria-selected="false">Unresolved comments
                  <span class="badge badge-light">{{ unresolved_comments_count }}</span>
                </a>
              </li>
              <li class="nav-item" @click.prevent="switchOrdersTab('pending_merchant_approval_items')" style="cursor:pointer">
                <a class="nav-link"  :class="{'active' : current_Tab === 'pending_merchant_approval_items' }" role="tab" aria-controls="pills-contact" aria-selected="false">Pending merchant approval
                  <span class="badge badge-light">{{ pending_merchant_approval_items_count }}</span>
                </a>
              </li>
              <li class="nav-item" @click.prevent="switchOrdersTab('shipping_in_week')" style="cursor:pointer">
                <a class="nav-link"  :class="{'active' : current_Tab === 'shipping_in_week' }" role="tab" aria-controls="pills-contact" aria-selected="false">Shipping this week
                  <span class="badge badge-light">{{ shipping_in_week_count }}</span>
                </a>
              </li>
              <li class="nav-item" @click.prevent="switchOrdersTab('all_items')" style="cursor:pointer">
                <a class="nav-link"  :class="{'active' : current_Tab === 'all_items' }" role="tab" aria-controls="pills-contact" aria-selected="false">All
                  <span class="badge badge-light">{{ all_items_count }}</span>
                </a>
              </li>
            </ul>
          </CCol>
          <CCol sm="3">
            <CRow>
              <CCol v-if="$can('can-filter-order-administrators')" class="pr-0">
                <v-select class="my-3" placeholder="Select Order Administrator" v-model="params.order_administrator_id" @input="getDashboardData('1', current_Tab)"
                          label="name" key="id" :options="order_administrators" ></v-select>
              </CCol>
              <CCol>
                <search-items v-model="params.search" :searchHandler="searchOrders" placeholder="Type Order No" ></search-items>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <div class="tab-content" >
              <template v-if="$can('assign-factory-to-shareable-orders')">
                <div class="tab-pane fade" :class="{'show active': current_Tab === 'pending_for_factory_assignment'}" role="tabpanel" aria-labelledby="pills-home-tab" v-show="current_Tab === 'pending_for_factory_assignment'">
                  <table class="urgent_action_items">
                    <tr>
                      <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_for_factory_assignment','order_no')">
                        <span v-if="current_Tab === 'pending_for_factory_assignment' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                        <span v-else><b-icon-sort-up /></span>
                        Order No
                      </th>
                      <th>Customer</th>
                      <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                      <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                      <th v-if="$can('order-listing-factory-column')">Factory</th>
                      <th>Reference</th>
                      <th>Status</th>
                      <th v-if="$can('assign-order-administrator')">Administrator</th>
                      <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_for_factory_assignment','status_updated_at','date')" >
                        <span v-if="current_Tab === 'pending_for_factory_assignment' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                        <span v-else><b-icon-sort-up /></span>
                        Date
                      </th>
                      <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_for_factory_assignment','status_updated_at','days')" >
                        <span v-if="current_Tab === 'pending_for_factory_assignment' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                        <span v-else><b-icon-sort-up /></span>
                        Days Since Action
                      </th>
                      <th>Quick Action</th>
                    </tr>
                    <template  v-if="isLoading || pending_for_factory_assignment.data.length === 0">
                      <td colspan="7">No Data exist</td>
                    </template>
                    <template v-else v-for="(pending_for_factory_assignment_item,index) in pending_for_factory_assignment.data">
                      <tr :key="index">
                        <td>
                          {{pending_for_factory_assignment_item.hasOwnProperty('order')? pending_for_factory_assignment_item.order.order_no:''}}
                        </td>
                        <td>
                          {{  
                            ( 
                              pending_for_factory_assignment_item.hasOwnProperty('order') 
                                ? (pending_for_factory_assignment_item.order.customer_name?.trim().length  
                                    ? pending_for_factory_assignment_item.order.customer_name  
                                    : pending_for_factory_assignment_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize 
                          }} 
                          <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(pending_for_factory_assignment_item.order.customer_id)" />
                        </td>
                        <td v-if="$can('order-listing-shipping-address-column')">
                          {{pending_for_factory_assignment_item.hasOwnProperty('order')?pending_for_factory_assignment_item.order.shipping_address:null | shippingAddress}}
                        </td>
                        <td v-if="$can('order-listing-merchant-column')">
                          {{pending_for_factory_assignment_item.hasOwnProperty('order')?pending_for_factory_assignment_item.order.company_name:'' | capitalize}}
                        </td>
                        <td v-if="$can('order-listing-factory-column')">
                          {{pending_for_factory_assignment_item.factory_name | capitalize}}
                        </td>
                        <td>
                          {{ pending_for_factory_assignment_item.order?.customer_reference_no || 'N/A' }}
                        </td>
                        <td class="position-relative">
                        <span class="factory_status" :class="pending_for_factory_assignment_item.status">
                          <span class="d-flex">
                            <span class="d-inline-flex" style="padding-right: 10px;">{{pending_for_factory_assignment_item.status | status}}</span>
                            <span class="dropdown_btn" @click="showFactoriesDropdown(pending_for_factory_assignment_item)">
                              <b-icon-chevron-down></b-icon-chevron-down>
                            </span>
                          </span>
                        </span>
                          <div class="assign_factory" v-if="pending_for_factory_assignment_item.editing">
                            <div :class="factory_product_index == 0 ? 'mt-1' : 'mt-3'"
                                 v-for="(factory_product, factory_product_index) in pending_for_factory_assignment_item.factory_products"
                                 :key="factory_product.id">
                              <strong>
                                {{factory_product.is_new_product ? factory_product.new_product_name : factory_product.product_name}}
                                <template v-if="factory_product.reorder_data">
                                  {{`(Reorder from ${factory_product.reorder_data.order_number}: made at: ${factory_product.product_last_factory})`}}
                                </template>
                              </strong>
                              <b-form-select v-model="factory_product.selected_factory_id" :options="factories" text-field="name"
                                             value-field="id" :disabled="pending_for_factory_assignment_item.updating ? true : false" @change="handleFactoryChange($event, factory_product_index)"/>
                            </div>
                            <div class="mt-1">
                              <strong>Assign Order Admin</strong>
                              <v-select style="height: 10%;" placeholder="Assign admin" v-model="pending_for_factory_assignment_item.order.order_administrator_id" :reduce="admin => admin.id" :value="pending_for_factory_assignment_item.order.order_administrator" label="name" :options="filteredOrderAdminsMap"/>
                            </div>
                            <div class="mt-2 d-flex" style="gap: 10px">
                              <template v-if="pending_for_factory_assignment_item.updating">
                                <Loading fillColor="#FF0000" title="Updating" style="cursor:pointer;"/>
                              </template>
                              <template v-else>
                                <b-button class="w-100" @click="cancelAssignFactory(pending_for_factory_assignment_item)">Cancel</b-button>
                                <b-button class="w-100" @click="validateFactoryAssignmentData(pending_for_factory_assignment_item)" variant="primary">Save</b-button>
                              </template>
                            </div>
                          </div>
                        </td>
                        <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                          <template v-if="pending_for_factory_assignment_item.factory_id">
                            <v-select style="height: 10%;" placeholder="Assign admin" v-model="pending_for_factory_assignment_item.order.order_administrator_id" :reduce="admin => admin.id" :value="pending_for_factory_assignment_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(pending_for_factory_assignment_item, order_administrators)" @input="updateOrderAdmin(pending_for_factory_assignment_item)"></v-select>
                          </template>
                          <template v-else>N/A</template>
                        </td>
                        <td>
                          {{pending_for_factory_assignment_item.order.created_at | date}}
                        </td>
                        <td>
                          {{pending_for_factory_assignment_item.order.created_at | ago}}
                        </td>
                        <td>
                          <!-- <template v-if="pending_for_factory_assignment_item.order.additional_fields && pending_for_factory_assignment_item.order.additional_fields.is_manual_order === true">
                            <b-button v-if="$can('upload-custom-techpack')" class="btn btn-secondary mx-2" @click="showCustomTechPackModal(pending_for_factory_assignment_item.order)">Custom TechPack</b-button>
                          </template> -->
                          
                          <TechPackButtons :order_item="pending_for_factory_assignment_item" :is_default="true" />                          
                          <button class="btn btn-secondary ml-2" v-if="$can('change-factory')" @click="showUpdateFactoryModal(pending_for_factory_assignment_item)">Change Factory</button>
                          <router-link  :to="`order/${pending_for_factory_assignment_item.order.id}/detail`" class="btn btn-secondary mx-2">Details <b-badge variant="danger" v-if="pending_for_factory_assignment_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{pending_for_factory_assignment_item.unresolved_comments_count}}</b-badge></router-link>
                          <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(pending_for_factory_assignment_item.order.id)"><b-icon-trash/></button>
                        </td>
                      </tr>
                    </template>

                  </table>
                  <div class="mt-5">
                    <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'pending_for_factory_assignment')"
                                              :pagination_object="pagination_object"
                                              v-if="pagination_object.total > 0"
                    />
                  </div>
                </div>
              </template>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'urgent_action_items'}" role="tabpanel" aria-labelledby="pills-home-tab" v-show="current_Tab === 'urgent_action_items'">
                <table class="urgent_action_items">
                  <tr>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('urgent_action_items','order_no')">
                      <span v-if="current_Tab === 'urgent_action_items' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Order No
                    </th>
                    <th>Customer</th>
                    <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                    <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                    <th v-if="$can('order-listing-factory-column')">Factory</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th v-if="$can('assign-order-administrator')">Administrator</th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('urgent_action_items','status_updated_at','date')" >
                      <span v-if="current_Tab === 'urgent_action_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Date
                    </th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('urgent_action_items','status_updated_at','days')" >
                      <span v-if="current_Tab === 'urgent_action_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Days Since Action
                    </th>
                    <th>Quick Action</th>
                  </tr>
                  <template  v-if="isLoading || urgent_action_items.data.length === 0">
                    <td colspan="7">No Data exist</td>
                  </template>
                  <template v-else v-for="(factory_await_item,index) in urgent_action_items.data">
                    <tr :key="index">
                      <td>
                        {{factory_await_item.hasOwnProperty('order')? factory_await_item.order.order_no:''}}
                      </td>
                      <td>
                        {{  
                            ( 
                              factory_await_item.hasOwnProperty('order')  
                                ? (factory_await_item.order.customer_name?.trim().length  
                                    ? factory_await_item.order.customer_name  
                                    : factory_await_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }} 
                        <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(factory_await_item.order.customer_id)" />
                      </td>
                      <td v-if="$can('order-listing-shipping-address-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.shipping_address:null | shippingAddress}}</td>
                      <td v-if="$can('order-listing-merchant-column')">{{factory_await_item.hasOwnProperty('order')?factory_await_item.order.company_name:'' | capitalize}}</td>
                      <td v-if="$can('order-listing-factory-column')">{{factory_await_item.factory_name | capitalize}}</td>
                      <td>
                        {{factory_await_item.order?.customer_reference_no || 'N/A'}}
                      </td>
                      <td>
                        <span class="factory_status" :class="factory_await_item.status">
                          <template v-if="factory_await_item.status === 'submitted_for_factory_review'">
                            Submitted For Merchant Review
                          </template>
                          <template v-else>
                            {{factory_await_item.status | status}}
                          </template>
                        </span>
                      </td>
                      <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                        <template v-if="factory_await_item.factory_id">  
                          <v-select style="height: 10%;" placeholder="Assign admin" v-model="factory_await_item.order.order_administrator_id" :reduce="admin => admin.id" :value="factory_await_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(factory_await_item,  order_administrators)" @input="updateOrderAdmin(factory_await_item)"></v-select>
                        </template>
                        <template v-else>
                          N/A
                        </template>
                      </td>
                      <td>
                        {{factory_await_item.status_updated_at | date}}
                      </td>
                      <td>
                        {{factory_await_item.status_updated_at | ago}}
                      </td>
                      <td>
                        <!-- Tech Pack button hide for old orders because of different old order data structure -->
                        <TechPackButtons :order_item="factory_await_item" :is_default="true" />
                        <template v-if="$can('download-customer-pdf') && factory_await_item.order.additional_fields && !factory_await_item.order.additional_fields.hasOwnProperty('is_manual_order')">
                          <a @click="openAWSFileFromOrder(factory_await_item.order)" class="btn btn-secondary mx-2">PDF</a>
                        </template>

                        <router-link  :to="`order/${factory_await_item.order?.id}/detail`" class="btn btn-secondary mx-2">Details</router-link>
                        <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(factory_await_item.order?.id)"><b-icon-trash/></button>
                      </td>
                    </tr>
                  </template>

                </table>
                <div class="mt-5">
                  <b-pagination :key="Math.random()"
                                v-model="urgent_action_items.current_page"
                                :total-rows="urgent_action_items.total"
                                :per-page="urgent_action_items.per_page"
                                aria-controls="itemList"
                                align="center"
                                @change="handlePagination($event, 'urgent_action_items')"
                                v-if="urgent_action_items.total > 0"
                  ></b-pagination>
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'pending_items'}" role="tabpanel" aria-labelledby="pills-home-tab" v-show="current_Tab === 'pending_items'">
                <table class="pending_items">
                  <tr>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_items','order_no')" >
                      <span v-if="current_Tab === 'pending_items' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Order No
                    </th>
                    <th>Customer</th>
                    <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                    <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                    <th v-if="$can('order-listing-factory-column')">Factory</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th v-if="$can('assign-order-administrator')">Administrator</th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_items','status_updated_at','date')">
                      <span v-if="current_Tab === 'pending_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Date
                    </th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_items','status_updated_at','days')">
                      <span v-if="current_Tab === 'pending_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Days Since Action
                    </th>
                    <th>Quick Action</th>
                  </tr>
                  <template  v-if="isLoading || pending_items.data.length === 0">
                    <td colspan="7">No Data exist</td>
                  </template>
                  <template v-else v-for="(pending_item,index) in pending_items.data">
                    <tr :key="index">
                      <td>
                        {{pending_item.hasOwnProperty('order')? pending_item.order.order_no:''}}
                      </td>
                      <td>
                        {{  
                            ( 
                              pending_item.hasOwnProperty('order')  
                                ? (pending_item.order.customer_name?.trim().length  
                                    ? pending_item.order.customer_name  
                                    : pending_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }} 
                        <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(pending_item.order.customer_id)" />
                      </td>
                      <td v-if="$can('order-listing-shipping-address-column')"> {{pending_item.hasOwnProperty('order')?pending_item.order.shipping_address:null | shippingAddress}}</td>
                      <td v-if="$can('order-listing-merchant-column')"> {{pending_item.hasOwnProperty('order')?pending_item.order.company_name:'' | capitalize}}</td>
                      <td v-if="$can('order-listing-factory-column')">{{pending_item.factory_name | capitalize}}</td>
                      <td>
                        {{pending_item.order?.customer_reference_no || 'N/A'}}
                      </td>
                      <td>
                        <span class="factory_status" :class="pending_item.status">
                          <template v-if="pending_item.status === 'submitted_for_factory_review'">
                            Submitted For Merchant Review
                          </template>
                          <template v-else>
                            {{pending_item.status | status}}
                          </template>
                        </span>
                      </td>
                      <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                        <template v-if="pending_item.factory_id">
                          <v-select style="height: 10%;" placeholder="Assign admin" v-model="pending_item.order.order_administrator_id" :reduce="admin => admin.id" :value="pending_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(pending_item, order_administrators)" @input="updateOrderAdmin(pending_item)"></v-select>
                        </template>
                        <template v-else> N/A </template>
                      </td>
                      <td>
                        {{pending_item.status_updated_at | date}}
                      </td>
                      <td>
                        {{pending_item.status_updated_at | ago}}
                      </td>
                      <td>
                        <!-- Tech Pack button hide for old orders because of different old order data structure -->
                        <TechPackButtons :order_item="pending_item" :is_default="true" />
                        <template v-if="$can('download-customer-pdf') && pending_item.order.additional_fields && !pending_item.order.additional_fields.hasOwnProperty('is_manual_order')">
                          <a @click="openAWSFileFromOrder(pending_item.order)" class="btn btn-secondary mx-2">PDF</a>
                        </template>
                        <router-link  :to="`order/${pending_item.order?.id}/detail`" class="btn btn-secondary mx-2">Details</router-link>
                        <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(pending_item.order?.id)"><b-icon-trash/></button>
                      </td>
                    </tr>
                  </template>

                </table>
                <div class="mt-5">
                  <b-pagination :key="Math.random()"
                                v-model="pending_items.current_page"
                                :total-rows="pending_items.total"
                                :per-page="pending_items.per_page"
                                aria-controls="itemList"
                                align="center"
                                @change="handlePagination($event, 'pending_items')"
                                v-if="pending_items.total > 0"
                  ></b-pagination>
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'customer_await_items'}" role="tabpanel" aria-labelledby="pills-profile-tab" v-show="current_Tab === 'customer_await_items'">
                <table class="customer_await_items">
                  <tr>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('customer_await_items','order_no')">
                      <span v-if="current_Tab === 'customer_await_items' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Order No
                    </th>
                    <th>Customer</th>
                    <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                    <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                    <th v-if="$can('order-listing-factory-column')">Factory</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th v-if="$can('assign-order-administrator')">Administrator</th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('customer_await_items','status_updated_at','date')">
                      <span v-if="current_Tab === 'customer_await_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Date
                    </th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('customer_await_items','status_updated_at','days')">
                      <span v-if="current_Tab === 'customer_await_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Days Since Action
                    </th>
                    <th>Quick Action</th>
                  </tr>
                  <template  v-if="isLoading || customer_await_items.data.length === 0">
                    <td colspan="7">No Data exist</td>
                  </template>
                  <template v-else v-for="(customer_await_item,index) in customer_await_items.data">
                    <tr :key="index">
                      <td>
                        {{customer_await_item.hasOwnProperty('order')? customer_await_item.order.order_no:''}}
                      </td>
                      <td>
                        {{  
                            ( 
                              customer_await_item.hasOwnProperty('order')  
                                ? (customer_await_item.order.customer_name?.trim().length  
                                    ? customer_await_item.order.customer_name  
                                    : customer_await_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }} 
                        <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(customer_await_item.order.customer_id)" />
                      </td>
                      <td v-if="$can('order-listing-shipping-address-column')"> {{customer_await_item.hasOwnProperty('order')?customer_await_item.order.shipping_address:null | shippingAddress}}</td>
                      <td v-if="$can('order-listing-merchant-column')"> {{customer_await_item.hasOwnProperty('order')?customer_await_item.order.company_name:'' | capitalize}}</td>
                      <td v-if="$can('order-listing-factory-column')">{{customer_await_item.factory_name | capitalize}}</td>
                      <td>
                        {{customer_await_item.order?.customer_reference_no || 'N/A'}}
                      </td>
                      <td>
                        <span class="factory_status" :class="customer_await_item.status">
                          <template v-if="customer_await_item.status === 'submitted_for_factory_review'">
                            Submitted For Merchant Review
                          </template>
                          <template v-else>
                            {{customer_await_item.status | status}}
                          </template>
                        </span>
                      </td>
                      <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                        <template v-if="customer_await_item.factory_id">
                          <v-select style="height: 10%;" placeholder="Assign admin" v-model="customer_await_item.order.order_administrator_id" :reduce="admin => admin.id" :value="customer_await_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(customer_await_item, order_administrators)" @input="updateOrderAdmin(customer_await_item)"></v-select>
                        </template>
                        <template v-else> N/A </template>
                      </td>
                      <td>
                        {{customer_await_item.order.created_at | date}}
                      </td>
                      <td>
                        {{customer_await_item.order.created_at | ago}}
                      </td>
                      <td>
                        <!-- <template v-if="customer_await_item.order.additional_fields && customer_await_item.order.additional_fields.is_manual_order === true">
                          <b-button v-if="$can('upload-custom-techpack')" class="btn btn-secondary mx-2" @click="showCustomTechPackModal(customer_await_item.order)">Custom TechPack</b-button>
                        </template> -->
                        
                        <TechPackButtons :order_item="customer_await_item" :is_default="true" />
                        <router-link  :to="`order/${customer_await_item.order?.id}/detail`" class="btn btn-secondary mx-2">Details <b-badge variant="danger" v-if="customer_await_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{customer_await_item.unresolved_comments_count}}</b-badge></router-link>
                        <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(customer_await_item.order?.id)"><b-icon-trash/></button>
                        <button class="btn btn-secondary ml-2" v-if="$can('change-factory')" @click="showUpdateFactoryModal(customer_await_item)">Change Factory</button>
                      </td>
                    </tr>
                  </template>
                </table>
                <div class="mt-5">
                  <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'customer_await_items')"
                                            :pagination_object="pagination_object"
                                            v-if="pagination_object.total > 0"
                  />
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'quote_requested_items'}" role="tabpanel" aria-labelledby="pills-profile-tab" v-show="current_Tab === 'quote_requested_items'" v-if="$can('show-quotes-tab')">
                <table class="customer_await_items">
                  <tr>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('quote_requested_items','order_no')">
                      <span v-if="current_Tab === 'quote_requested_items' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Quote No
                    </th>
                    <th>Customer</th>
                    <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                    <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                    <th v-if="$can('order-listing-factory-column')">Factory</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th v-if="$can('assign-order-administrator')">Administrator</th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('customer_await_items','status_updated_at','date')">
                      <span v-if="current_Tab === 'quote_requested_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Date
                    </th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('customer_await_items','status_updated_at','days')">
                      <span v-if="current_Tab === 'quote_requested_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Days Since Action
                    </th>
                    <th>Quick Action</th>
                  </tr>
                  <template  v-if="isLoading || quote_requested_items.data.length === 0">
                    <td colspan="7">No Data exist</td>
                  </template>
                  <template v-else v-for="(quote_requested_item,index) in quote_requested_items.data">
                    <tr :key="index">
                      <td>
                        {{quote_requested_item.hasOwnProperty('order')? quote_requested_item.order.order_no:''}}
                      </td>
                      <td>
                        {{  
                            ( 
                              quote_requested_item.hasOwnProperty('order')  
                                ? (quote_requested_item.order.customer_name?.trim().length  
                                    ? quote_requested_item.order.customer_name  
                                    : quote_requested_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }} 
                      </td>
                      <td v-if="$can('order-listing-shipping-address-column')"> {{quote_requested_item.hasOwnProperty('order')?quote_requested_item.order.shipping_address:null | shippingAddress}}</td>
                      <td v-if="$can('order-listing-merchant-column')"> {{quote_requested_item.hasOwnProperty('order')?quote_requested_item.order.company_name:'' | capitalize}}</td>
                      <td v-if="$can('order-listing-factory-column')">{{quote_requested_item.factory_name | capitalize}}</td>
                      <td>
                        {{quote_requested_item.order?.customer_reference_no || 'N/A'}}
                      </td>
                      <td>
                        <span class="factory_status" :class="quote_requested_item.status">
                          <template v-if="quote_requested_item.status === 'submitted_for_factory_review'">
                            Submitted For Merchant Review
                          </template>
                          <template v-else>
                            {{quote_requested_item.status | status}}
                          </template>
                        </span>
                      </td>
                      <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                        <template v-if="quote_requested_item.factory_id">
                          <v-select style="height: 10%;" placeholder="Assign admin" v-model="quote_requested_item.order.order_administrator_id" :reduce="admin => admin.id" :value="quote_requested_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(quote_requested_item, order_administrators)" @input="updateOrderAdmin(quote_requested_item)"></v-select>
                        </template>
                        <template v-else> N/A </template>
                      </td>
                      <td>
                        {{quote_requested_item.order.created_at | date}}
                      </td>
                      <td>
                        {{quote_requested_item.order.created_at | ago}}
                      </td>
                      <td>

                        <button v-if="quote_requested_item.status == 'quote_requested' && quote_requested_item.order.admin_salesrep_id == null" class="btn btn-secondary ml-2"  @click="provideQuotePrice(quote_requested_item.order)">Provide Quote</button>
                        <button v-if="quote_requested_item.status == 'quote_provided'" class="btn btn-secondary ml-2"  @click="notifyCustomerForQuote(quote_requested_item.order.id)">Notify Customer</button>
                        <template v-if="$can('download-customer-pdf') && quote_requested_item.order.additional_fields && !quote_requested_item.order.additional_fields.hasOwnProperty('is_manual_order')">
                          <a @click="openAWSFileFromOrder(quote_requested_item.order)" class="btn btn-secondary mx-2">PDF</a>
                        </template>
                        <button class="btn btn-secondary ml-2" v-if="$can('change-factory')" @click="showUpdateFactoryModal(quote_requested_item)">Change Factory</button>
                        <router-link  :to="`order/${quote_requested_item.order?.id}/detail`" class="btn btn-secondary mx-2">Details <b-badge variant="danger" v-if="quote_requested_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{quote_requested_item.unresolved_comments_count}}</b-badge></router-link>
                      </td>
                    </tr>
                  </template>
                </table>
                <div class="mt-5">
                  <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'quote_requested_items')"
                                            :pagination_object="pagination_object"
                                            v-if="pagination_object.total > 0"
                  />
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'all_items'}" role="tabpanel" aria-labelledby="pills-contact-tab" v-if="current_Tab === 'all_items'">

                <div>
                  <div class="mt-2">
                    <h3 class="my-2">All Orders</h3>
                    <table class="urgent_action_items">
                      <tr>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('all_items','order_no')">
                          <span v-if="current_Tab === 'all_items' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Order No
                        </th>
                        <th>Customer</th>
                        <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                        <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                        <th v-if="$can('order-listing-factory-column')">Factory</th>
                        <th>Reference</th>
                        <th>Status</th>
                        <th v-if="$can('assign-order-administrator')">Administrator</th>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('all_items','status_updated_at','date')">
                          <span v-if="current_Tab === 'all_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Date
                        </th>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('all_items','status_updated_at','days')">
                          <span v-if="current_Tab === 'all_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Days Since Action
                        </th>
                        <th>Quick Action</th>
                      </tr>
                      <template  v-if="isLoading || all_items.data.length === 0">
                        <td colspan="7">No Data exist</td>
                      </template>
                      <template v-else v-for="(factory_await_item,index) in all_items.data">
                        <tr :key="index">
                          <td>
                            {{factory_await_item.hasOwnProperty('order')? factory_await_item.order.order_no:''}}
                          </td>
                          <td>
                        {{  
                            ( 
                              factory_await_item.hasOwnProperty('order')  
                                ? (factory_await_item.order.customer_name?.trim().length  
                                    ? factory_await_item.order.customer_name  
                                    : factory_await_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }}
                            <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(factory_await_item.order.customer_id)" />
                          </td>
                          <td v-if="$can('order-listing-shipping-address-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.shipping_address:null | shippingAddress}}</td>
                          <td v-if="$can('order-listing-merchant-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.company_name:'' | capitalize}}</td>
                          <td v-if="$can('order-listing-factory-column')">{{factory_await_item.factory_name | capitalize}}</td>
                          <td>
                            {{factory_await_item.order?.customer_reference_no || 'N/A'}}
                          </td>
                          <td>
                            <span class="factory_status" :class="factory_await_item.status">
                              <template v-if="factory_await_item.status === 'submitted_for_factory_review'">
                                Submitted For Merchant Review
                              </template>
                              <template v-else>
                                {{factory_await_item.status | status}}
                              </template>
                            </span>
                          </td>
                          <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                            <template v-if="factory_await_item.factory_id">
                              <v-select style="height: 10%;" placeholder="Assign admin" v-model="factory_await_item.order.order_administrator_id" :reduce="admin => admin.id" :value="factory_await_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(factory_await_item,order_administrators)" @input="updateOrderAdmin(factory_await_item)"></v-select>
                            </template>
                            <template v-else> N/A </template>
                          </td>
                          <td>
                            {{factory_await_item.order.created_at | date}}
                          </td>
                          <td>
                            {{factory_await_item.order.created_at | ago}}
                          </td>
                          <td>
                            <!-- <template v-if="factory_await_item.order.additional_fields && factory_await_item.order.additional_fields.is_manual_order === true">
                              <b-button v-if="$can('upload-custom-techpack')" class="btn btn-secondary mx-2" @click="showCustomTechPackModal(factory_await_item.order)">Custom TechPack</b-button>
                            </template> -->
              
                            <TechPackButtons :order_item="factory_await_item" :is_default="true" />
                            <router-link  :to="`order/${factory_await_item.order?.id}/detail`" class="btn btn-secondary mx-2">
                              Details <b-badge variant="danger" v-if="factory_await_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{factory_await_item.unresolved_comments_count}}</b-badge>
                            </router-link>

                            <button @click="showPriceBreakdown(factory_await_item)" class="btn btn-secondary ml-2" v-if="factory_await_item.price_list_detail.currency_code && factory_await_item.price_list_detail.curency_symbol">Order Price {{`${factory_await_item.price_list_detail.currency_code} ` + `${factory_await_item.price_list_detail.curency_symbol}` + `${factory_await_item.price_list_detail.item_net_total?.toFixed(2)}`}}</button>
                            <button class="btn btn-secondary ml-2" v-if="$can('change-factory')" @click="showUpdateFactoryModal(factory_await_item)">Change Factory</button>
                            <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(factory_await_item.order?.id)"><b-icon-trash/></button>
                          </td>
                        </tr>
                      </template>

                    </table>
                    <div class="mt-5">
                      <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'all_items')"
                                                :pagination_object="pagination_object"
                                                v-if="pagination_object.total > 0"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'shipping_in_week'}" role="tabpanel" aria-labelledby="pills-contact-tab" v-if="current_Tab === 'shipping_in_week'">

                <div>
                  <div class="mt-2">
                    <h3 class="my-2">All Orders</h3>
                    <table class="urgent_action_items">
                      <tr>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('shipping_in_week','order_no')">
                          <span v-if="current_Tab === 'shipping_in_week' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Order No
                        </th>
                        <th>Customer</th>
                        <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                        <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                        <th v-if="$can('order-listing-factory-column')">Factory</th>
                        <th>Reference</th>
                        <th>Status</th>
                        <th v-if="$can('assign-order-administrator')">Administrator</th>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('shipping_in_week','status_updated_at','date')">
                          <span v-if="current_Tab === 'shipping_in_week' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Date
                        </th>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('shipping_in_week','status_updated_at','days')">
                          <span v-if="current_Tab === 'shipping_in_week' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Days Since Action
                        </th>
                        <th>Quick Action</th>
                      </tr>
                      <template  v-if="isLoading || shipping_in_week.data.length === 0">
                        <td colspan="7">No Data exist</td>
                      </template>
                      <template v-else v-for="(factory_await_item,index) in shipping_in_week.data">
                        <tr :key="index">
                          <td>
                            {{factory_await_item.hasOwnProperty('order')? factory_await_item.order.order_no:''}}
                          </td>
                          <td>
                        {{  
                            ( 
                              factory_await_item.hasOwnProperty('order')  
                                ? (factory_await_item.order.customer_name?.trim().length  
                                    ? factory_await_item.order.customer_name  
                                    : factory_await_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }} 
                            <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(factory_await_item.order.customer_id)" />
                          </td>
                          <td v-if="$can('order-listing-shipping-address-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.shipping_address:null | shippingAddress}}</td>
                          <td v-if="$can('order-listing-merchant-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.company_name:'' | capitalize}}</td>
                          <td v-if="$can('order-listing-factory-column')">{{factory_await_item.factory_name | capitalize}}</td>
                          <td>
                            {{factory_await_item.order?.customer_reference_no || 'N/A'}}
                          </td>
                          <td>
                            <span class="factory_status" :class="factory_await_item.status">
                              <template v-if="factory_await_item.status === 'submitted_for_factory_review'">
                                Submitted For Merchant Review
                              </template>
                              <template v-else>
                                {{factory_await_item.status | status}}
                              </template>
                            </span>
                          </td>
                          <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                            <template v-if="factory_await_item.factory_id">  
                              <v-select style="height: 10%;" placeholder="Assign admin" v-model="factory_await_item.order.order_administrator_id" :reduce="admin => admin.id" :value="factory_await_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(factory_await_item,order_administrators)" @input="updateOrderAdmin(factory_await_item)"></v-select>
                            </template>
                            <template v-else> N/A </template>
                          </td>
                          <td>
                            {{factory_await_item.order.created_at | date}}
                          </td>
                          <td>
                            {{factory_await_item.order.created_at | ago}}
                          </td>
                          <td>
                            <!-- <template v-if="factory_await_item.order.additional_fields && factory_await_item.order.additional_fields.is_manual_order === true">
                              <b-button v-if="$can('upload-custom-techpack')" class="btn btn-secondary mx-2" @click="showCustomTechPackModal(factory_await_item.order)">Custom TechPack</b-button>
                            </template> -->
                            <TechPackButtons :order_item="factory_await_item" :is_default="true" />
                            <router-link  :to="`order/${factory_await_item.order?.id}/detail`" class="btn btn-secondary mx-2">
                              Details <b-badge variant="danger" v-if="factory_await_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{factory_await_item.unresolved_comments_count}}</b-badge>
                            </router-link>

                            <button @click="showPriceBreakdown(factory_await_item)" class="btn btn-secondary ml-2" v-if="factory_await_item.price_list_detail.currency_code && factory_await_item.price_list_detail.curency_symbol">Order Price {{`${factory_await_item.price_list_detail.currency_code} ` + `${factory_await_item.price_list_detail.curency_symbol}` + `${factory_await_item.price_list_detail.item_net_total?.toFixed(2)}`}}</button>
                            <button class="btn btn-secondary ml-2" v-if="$can('change-factory')" @click="showUpdateFactoryModal(factory_await_item)">Change Factory</button>
                            <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(factory_await_item.order?.id)"><b-icon-trash/></button>
                          </td>
                        </tr>
                      </template>

                    </table>
                    <div class="mt-5">
                      <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'shipping_in_week')"
                                                :pagination_object="pagination_object"
                                                v-if="pagination_object.total > 0"
                      />
                   </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'shipping_in_week'}" role="tabpanel" aria-labelledby="pills-contact-tab" v-if="current_Tab === 'shipping_in_week'">

                <div>
                  <div class="mt-2">
                    <h3 class="my-2">All Orders</h3>
                    <table class="urgent_action_items">
                      <tr>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('shipping_in_week','order_no')">
                          <span v-if="current_Tab === 'shipping_in_week' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Order No
                        </th>
                        <th>Customer</th>
                        <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                        <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                        <th v-if="$can('order-listing-factory-column')">Factory</th>
                        <th>Reference</th>
                        <th>Status</th>
                        <th v-if="$can('assign-order-administrator')">Administrator</th>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('shipping_in_week','status_updated_at','date')">
                          <span v-if="current_Tab === 'shipping_in_week' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Date
                        </th>
                        <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('shipping_in_week','status_updated_at','days')">
                          <span v-if="current_Tab === 'shipping_in_week' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                          <span v-else><b-icon-sort-up /></span>
                          Days Since Action
                        </th>
                        <th>Quick Action</th>
                      </tr>
                      <template  v-if="isLoading || shipping_in_week.data.length === 0">
                        <td colspan="7">No Data exist</td>
                      </template>
                      <template v-else v-for="(factory_await_item,index) in shipping_in_week.data">
                        <tr :key="index">
                          <td>
                            {{factory_await_item.hasOwnProperty('order')? factory_await_item.order.order_no:''}}
                          </td>
                          <td>
                            {{factory_await_item.hasOwnProperty('order') ? factory_await_item.order.customer_name : ''  | capitalize}}
                            <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(factory_await_item.order.customer_id)" />
                          </td>
                          <td v-if="$can('order-listing-shipping-address-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.shipping_address:null | shippingAddress}}</td>
                          <td v-if="$can('order-listing-merchant-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.company_name:'' | capitalize}}</td>
                          <td v-if="$can('order-listing-factory-column')">{{factory_await_item.factory_name | capitalize}}</td>
                          <td>
                            {{factory_await_item.order?.customer_reference_no || 'N/A'}}
                          </td>
                          <td>
                            <span class="factory_status" :class="factory_await_item.status">
                              <template v-if="factory_await_item.status === 'submitted_for_factory_review'">
                                Submitted For Merchant Review
                              </template>
                              <template v-else>
                                {{factory_await_item.status | status}}
                              </template>
                            </span>
                          </td>
                          <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                            <template v-if="factory_await_item.factory_id">
                              <v-select style="height: 10%;" placeholder="Assign admin" v-model="factory_await_item.order.order_administrator_id" :reduce="admin => admin.id" :value="factory_await_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(factory_await_item, order_administrators)" @input="updateOrderAdmin(factory_await_item)"></v-select>
                            </template>
                            <template v-else> N/A </template>
                          </td>
                          <td>
                            {{factory_await_item.order.created_at | date}}
                          </td>
                          <td>
                            {{factory_await_item.order.created_at | ago}}
                          </td>
                          <td>
                            <!-- <template v-if="factory_await_item.order.additional_fields && factory_await_item.order.additional_fields.is_manual_order === true">
                              <b-button v-if="$can('upload-custom-techpack')" class="btn btn-secondary mx-2" @click="showCustomTechPackModal(factory_await_item.order)">Custom TechPack</b-button>
                            </template> -->
                            <TechPackButtons :order_item="factory_await_item" :is_default="true" />
                            <router-link  :to="`order/${factory_await_item.order?.id}/detail`" class="btn btn-secondary mx-2">
                              Details <b-badge variant="danger" v-if="factory_await_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{factory_await_item.unresolved_comments_count}}</b-badge>
                            </router-link>

                            <button @click="showPriceBreakdown(factory_await_item)" class="btn btn-secondary ml-2" v-if="factory_await_item.price_list_detail.currency_code && factory_await_item.price_list_detail.curency_symbol">Order Price {{`${factory_await_item.price_list_detail.currency_code} ` + `${factory_await_item.price_list_detail.curency_symbol}` + `${factory_await_item.price_list_detail.item_net_total?.toFixed(2)}`}}</button>
                            <button class="btn btn-secondary ml-2" v-if="$can('change-factory')" @click="showUpdateFactoryModal(factory_await_item)">Change Factory</button>
                            <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(factory_await_item.order?.id)"><b-icon-trash/></button>
                          </td>
                        </tr>
                      </template>

                    </table>
                    <div class="mt-5">
                      <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'shipping_in_week')"
                                                :pagination_object="pagination_object"
                                                v-if="pagination_object.total > 0"
                      />
                   </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'reorders'}" role="tabpanel" aria-labelledby="pills-contact-tab" v-if="current_Tab === 'reorders'">
                <table class="customer_await_items">
                  <tr>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('reorders','order_no')">
                      <span v-if="current_Tab === 'reorders' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Order No
                    </th>
                    <th>Customer</th>
                    <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                    <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                    <th v-if="$can('order-listing-factory-column')">Factory</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th v-if="$can('assign-order-administrator')">Administrator</th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('reorders','status_updated_at','date')">
                      <span v-if="current_Tab === 'reorders' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Date
                    </th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('reorders','status_updated_at','days')">
                      <span v-if="current_Tab === 'reorders' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Days Since Action
                    </th>
                    <th>Quick Action</th>
                  </tr>
                  <template  v-if="isLoading || reorders.data.length === 0">
                    <td colspan="7">No Data exist</td>
                  </template>
                  <template v-else v-for="(reorder_item,index) in reorders.data">
                    <tr :key="index">
                      <td>
                        {{reorder_item.hasOwnProperty('order')? reorder_item.order.order_no:''}}
                      </td>
                      <td>
                        {{  
                            ( 
                              reorder_item.hasOwnProperty('order')  
                                ? (reorder_item.order.customer_name?.trim().length  
                                    ? reorder_item.order.customer_name  
                                    : reorder_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }} 
                        <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(reorder_item.order.customer_id)" />
                      </td>
                      <td v-if="$can('order-listing-shipping-address-column')"> {{reorder_item.hasOwnProperty('order')?reorder_item.order.shipping_address:null | shippingAddress}}</td>
                      <td v-if="$can('order-listing-merchant-column')"> {{reorder_item.hasOwnProperty('order')?reorder_item.order.company_name:'' | capitalize}}</td>
                      <td v-if="$can('order-listing-factory-column')">{{reorder_item.factory_name | capitalize}}</td>
                      <td>
                        {{reorder_item.order?.customer_reference_no || 'N/A'}}
                      </td>
                      <td>
                        <span class="factory_status" :class="reorder_item.status">
                          <template v-if="reorder_item.status === 'submitted_for_factory_review'">
                            Submitted For Merchant Review
                          </template>
                          <template v-else>
                            {{reorder_item.status | status}}
                          </template>
                        </span>
                      </td>
                      <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                        <template v-if="reorder_item.factory_id">
                          <v-select style="height: 10%;" placeholder="Assign admin" v-model="reorder_item.order.order_administrator_id" :reduce="admin => admin.id" :value="reorder_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(reorder_item, order_administrators)" @input="updateOrderAdmin(reorder_item)"></v-select>
                        </template>
                        <template v-else> N/A </template>
                      </td>
                      <td>
                        {{reorder_item.status_updated_at | date}}
                      </td>
                      <td>
                        {{reorder_item.status_updated_at | ago}}
                      </td>
                      <td>
                          <TechPackButtons :order_item="reorder_item" :is_default="true" />
                        <router-link  :to="`order/${reorder_item.order?.id}/detail`" class="btn btn-secondary mx-2">Details <b-badge variant="danger" v-if="reorder_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{reorder_item.unresolved_comments_count}}</b-badge></router-link>
                        <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(reorder_item.order?.id)"><b-icon-trash/></button>
                      </td>
                    </tr>
                  </template>
                </table>
                <div class="mt-5">
                  <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'reorders')"
                                            :pagination_object="pagination_object"
                                            v-if="pagination_object.total > 0"
                  />
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'unresolved_comments'}" role="tabpanel" aria-labelledby="pills-home-tab" v-show="current_Tab === 'unresolved_comments'">
                <table class="urgent_action_items">
                  <tr>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('unresolved_comments','order_no')">
                      <span v-if="current_Tab === 'unresolved_comments' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Order No
                    </th>
                    <th>Customer</th>
                    <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                    <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                    <th v-if="$can('order-listing-factory-column')">Factory</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th v-if="$can('assign-order-administrator')">Administrator</th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('unresolved_comments','status_updated_at','date')" >
                      <span v-if="current_Tab === 'unresolved_comments' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Date
                    </th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('unresolved_comments','status_updated_at','days')" >
                      <span v-if="current_Tab === 'unresolved_comments' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Days Since Action
                    </th>
                    <th>Quick Action</th>
                  </tr>
                  <template  v-if="isLoading || unresolved_comments.data.length === 0">
                    <td colspan="7">No Data exist</td>
                  </template>
                  <template v-else v-for="(factory_await_item,index) in unresolved_comments.data">
                    <tr :key="index">
                      <td>
                        {{factory_await_item.hasOwnProperty('order')? factory_await_item.order.order_no:''}}
                      </td>
                      <td>
                        {{  
                            ( 
                              factory_await_item.hasOwnProperty('order')  
                                ? (factory_await_item.order.customer_name?.trim().length  
                                    ? factory_await_item.order.customer_name  
                                    : factory_await_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }}
                        <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(factory_await_item.order.customer_id)" />
                      </td>
                      <td v-if="$can('order-listing-shipping-address-column')"> {{factory_await_item.hasOwnProperty('order')?factory_await_item.order.shipping_address:null | shippingAddress}}</td>
                      <td v-if="$can('order-listing-merchant-column')">{{factory_await_item.hasOwnProperty('order')?factory_await_item.order.company_name:'' | capitalize}}</td>
                      <td v-if="$can('order-listing-factory-column')">{{factory_await_item.factory_name | capitalize}}</td>
                      <td>
                        {{factory_await_item.order?.customer_reference_no || 'N/A'}}
                      </td>
                      <td>
                        <span class="factory_status" :class="factory_await_item.status">
                          <template v-if="factory_await_item.status === 'submitted_for_factory_review'">
                            Submitted For Merchant Review
                          </template>
                          <template v-else>
                            {{factory_await_item.status | status}}
                          </template>
                        </span>
                      </td>
                      <td v-if="$can('assign-order-administrator')" style="width: 12%;">
                        <template v-if="factory_await_item.factory_id">
                          <v-select style="height: 10%;" placeholder="Assign admin" v-model="factory_await_item.order.order_administrator_id" :reduce="admin => admin.id" :value="factory_await_item.order.order_administrator" label="name" :options="getOrderAdminsbyFactoryId(factory_await_item, order_administrators)" @input="updateOrderAdmin(factory_await_item)"></v-select>
                        </template>
                        <template v-else>
                          N/A
                        </template>  
                       
                      </td>
                      <td>
                        {{factory_await_item.status_updated_at | date}}
                      </td>
                      <td>
                        {{factory_await_item.status_updated_at | ago}}
                      </td>
                      <td>
                        <TechPackButtons :order_item="factory_await_item" :is_default="true" />
                        <template v-if="$can('download-customer-pdf') && factory_await_item.order.additional_fields && !factory_await_item.order.additional_fields.hasOwnProperty('is_manual_order')">
                          <a @click="openAWSFileFromOrder(factory_await_item.order)" class="btn btn-secondary mx-2">PDF</a>
                        </template>

                        <router-link  :to="`order/${factory_await_item.order?.id}/detail`" class="btn btn-secondary mx-2">Details <b-badge variant="danger" v-if="factory_await_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{factory_await_item.unresolved_comments_count}}</b-badge></router-link>
                        <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(factory_await_item.order?.id)"><b-icon-trash/></button>
                      </td>
                    </tr>
                  </template>

                </table>
                <div class="mt-5">
                  <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'unresolved_comments')"
                                            :pagination_object="pagination_object"
                                            v-if="pagination_object.total > 0"
                  />
                </div>
              </div>
              <div class="tab-pane fade" :class="{'show active': current_Tab === 'pending_merchant_approval_items'}" role="tabpanel" aria-labelledby="pills-home-tab" v-show="current_Tab === 'pending_merchant_approval_items'">
                <table class="urgent_action_items">
                  <tr>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_merchant_approval_items','order_no')">
                      <span v-if="current_Tab === 'pending_merchant_approval_items' && params.sortBy === 'order_no' && params.sortOrder === 'desc'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Order No
                    </th>
                    <th>Customer</th>
                    <th v-if="$can('order-listing-shipping-address-column')">Shipping Address</th>
                    <th v-if="$can('order-listing-merchant-column')">Merchant</th>
                    <th v-if="$can('order-listing-factory-column')">Factory</th>
                    <th>Reference</th>
                    <th>Status</th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_merchant_approval_items','status_updated_at','date')" >
                      <span v-if="current_Tab === 'pending_merchant_approval_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'date'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Date
                    </th>
                    <th style="vertical-align: top;cursor: pointer;user-select: none; " @click.prevent="sortOrders('pending_merchant_approval_items','status_updated_at','days')" >
                      <span v-if="current_Tab === 'pending_merchant_approval_items' && params.sortBy === 'status_updated_at' && params.sortOrder === 'desc' && params.optional === 'days'"><b-icon-sort-down /></span>
                      <span v-else><b-icon-sort-up /></span>
                      Days Since Action
                    </th>
                    <th>Quick Action</th>
                  </tr>
                  <template  v-if="isLoading || pending_merchant_approval_items.data.length === 0">
                    <td colspan="7">No Data exist</td>
                  </template>
                  <template v-else v-for="(pending_merchant_approval_item,index) in pending_merchant_approval_items.data">
                    <tr :key="index">
                      <td>
                        {{pending_merchant_approval_item.hasOwnProperty('order')? pending_merchant_approval_item.order.order_no:''}}
                      </td>
                      <td>
                        {{  
                            ( 
                              pending_merchant_approval_item.hasOwnProperty('order')  
                                ? (pending_merchant_approval_item.order.customer_name?.trim().length  
                                    ? pending_merchant_approval_item.order.customer_name  
                                    : pending_merchant_approval_item.order.customer_email 
                                  )  
                                : '' 
                            ) | capitalize  
                          }} 
                        <Key fillColor="#E1A144" title="login as user" @click="loginCustomer(pending_merchant_approval_item.order.customer_id)" />
                      </td>
                      <td v-if="$can('order-listing-shipping-address-column')"> {{pending_merchant_approval_item.hasOwnProperty('order')?pending_merchant_approval_item.order.shipping_address:null | shippingAddress}}</td>
                      <td v-if="$can('order-listing-merchant-column')">{{pending_merchant_approval_item.hasOwnProperty('order')?pending_merchant_approval_item.order.company_name:'' | capitalize}}</td>
                      <td v-if="$can('order-listing-factory-column')">{{pending_merchant_approval_item.factory_name | capitalize}}</td>
                      <td>
                        {{pending_merchant_approval_item.order?.customer_reference_no || 'N/A'}}
                      </td>
                      <td>
                        <span class="factory_status" :class="pending_merchant_approval_item.status">
                          <template v-if="pending_merchant_approval_item.status === 'submitted_for_factory_review'">
                            Submitted For Merchant Review
                          </template>
                          <template v-else>
                            {{pending_merchant_approval_item.status | status}}
                          </template>
                        </span>
                      </td>
                      <td>
                        {{pending_merchant_approval_item.status_updated_at | date}}
                      </td>
                      <td>
                        {{pending_merchant_approval_item.status_updated_at | ago}}
                      </td>
                      <td>
                        <!-- Tech Pack button hide for old orders because of different old order data structure -->
                        
                        <TechPackButtons :order_item="pending_merchant_approval_item" :is_default="true" />
                        <template v-if="$can('download-customer-pdf') && pending_merchant_approval_item.order.additional_fields && !pending_merchant_approval_item.order.additional_fields.hasOwnProperty('is_manual_order')">
                          <a @click="openAWSFileFromOrder(pending_merchant_approval_item.order)"  class="btn btn-secondary mx-2">PDF</a>
                        </template>

                        <router-link  :to="`order/${pending_merchant_approval_item.order?.id}/detail`" class="btn btn-secondary mx-2">Details <b-badge variant="danger" v-if="pending_merchant_approval_item.unresolved_comments_count > 0 && $can('can-resolve-comment')">{{pending_merchant_approval_item.unresolved_comments_count}}</b-badge></router-link>
                        <button class="btn btn-secondary ml-2" v-if="$can('delete-order')" @click="deleteOrder(pending_merchant_approval_item.order?.id)"><b-icon-trash/></button>
                      </td>
                    </tr>
                  </template>

                </table>
                <div class="mt-5">
                  <pagination-with-per-page :key="Math.random()" @pagination-updated="handlePagination($event, 'pending_merchant_approval_items')"
                                            :pagination_object="pagination_object"
                                            v-if="pagination_object.total > 0"
                  />
                </div>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <b-modal no-close-on-backdrop hide-footer ref="quoteAcceptModal"  id="modal-1" :title="`Provide Quote`">
      <CRow>

        <CCol class="col-12">
          <label class="required">Provide Quote</label>
          <b-form-textarea v-validate="{required: true, min: 3}" id="textarea" v-model="quote.quote_text" placeholder="Enter quote text" rows="2"
          ></b-form-textarea>
          <b-button @click="saveQuotePrice" class="mt-2 float-right" variant="primary">Save</b-button>
        </CCol>
      </CRow>
    </b-modal>
    <b-modal no-close-on-backdrop hide-footer ref="priceBreakdownModal" id="modal-2" title="Order price breakdown" size="lg">
      <template v-for="(sku, sku_idx) in product_price_breakdown">
        <div class="mb-5" :key="`sku_${sku_idx}_breakdown`">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex justify-content-between align-items-center">
              <img class="img-thumbnail img-fluid border-0" :src="`${storage_url}/${sku.img_url}`" style="width: 70px; background-color: transparent" alt="">
              <div class="d-flex flex-column">
                <span class="font-lg font-weight-bold">{{sku.name}}</span>
                <span class="text-black-50">SKU: {{sku.sku_number}}</span>
              </div>
            </div>
            <div class="d-flex justify-content-between font-lg gap-x-5">
              <span v-if="sku.price_detail.is_fixed === 1">{{formatPrice(sku.price_detail.fixed_price)}} x {{sku.quantity}}</span>
              <span v-else>{{formatPrice(sku.price_detail.discounted_price)}} x {{sku.quantity}}</span>
              <span>{{formatPrice(sku.subTotal)}}<strong>{{sku.price_detail.currency_symbol}}</strong></span>
            </div>
          </div>
          <strong class="font-lg" v-if="sku.addons.length">Addons:</strong>
          <template v-for="(addon, addon_idx) in sku.addons">
            <div v-if="sku.addons" class="font-lg d-flex justify-content-between" style="margin-left: 9%" :key="`addon_${addon_idx}_sku_${sku_idx}_breakdown`">
              <span>{{addon.name}} </span>
              <div v-if="addon.price_detail && addon.price_detail.net_price">
                <span class="mr-4" v-if="addon.price_detail.is_fixed">{{formatPrice(addon.price_detail.fixed_price)}} x {{sku.quantity}}</span>
                <span class="mr-4" v-else>{{formatPrice(addon.price_detail.discounted_price)}} x {{sku.quantity}}</span>
                <span>{{formatPrice(addon.subTotal)}}<strong>{{addon.price_detail.currency_symbol}}</strong></span>
              </div>
              <div v-else>
                <span>N/A</span>
              </div>
            </div>
          </template>
          <strong class="font-lg" v-if="sku.groupedAddons.length">Grouped Addons:</strong>
          <template v-for="(grouped_addon, grouped_addon_idx) in sku.groupedAddons">
            <div v-if="sku.groupedAddons" class="font-lg d-flex justify-content-between" style="margin-left: 9%" :key="`addon_${grouped_addon_idx}_sku_${sku_idx}_breakdown`">
              <span>{{ grouped_addon.name }}</span>
              <div v-if="grouped_addon.net_price">
                <span class="mr-4">{{ grouped_addon.net_price.toFixed(2) }} x {{ sku.quantity }}</span>
                <span>{{ (grouped_addon.net_price*sku.quantity).toFixed(2) }}{{ sku.price_detail.currency_symbol }}</span>
              </div>
              <div v-else>
                <span>N/A</span>
              </div>
            </div>
          </template>
          <strong class="font-lg" v-if="sku.ungroupedAddons.length">Ungrouped Addons:</strong>
          <template v-for="(ungrouped_addon, ungrouped_addon_idx) in sku.ungroupedAddons">
            <div v-if="sku.ungroupedAddons" class="font-lg d-flex justify-content-between" style="margin-left: 9%" :key="`addon_${ungrouped_addon_idx}_sku_${sku_idx}_breakdown`">
              <span>{{ ungrouped_addon.name }}</span>
              <div v-if="ungrouped_addon.net_price">
                <span class="mr-4">{{ ungrouped_addon.net_price.toFixed(2) }} x {{ sku.quantity }}</span>
                <span>{{ (ungrouped_addon.net_price*sku.quantity).toFixed(2) }}{{ sku.price_detail.currency_symbol }}</span>
              </div>
              <div v-else>
                <span>N/A</span>
              </div>
            </div>
          </template>
        </div>
      </template>
      <span class="float-right mt-5 font-lg"><strong>Sub Total: </strong>{{order_price_list_detail.item_net_total?.toFixed(2)}}<strong>{{order_price_list_detail.curency_symbol}}</strong></span>
    </b-modal>
    <b-modal no-close-on-backdrop ref="exportOrderPriceModal" id="modal-2" title="Export Order Prices" size="lg" @hide="closeExportOrderPricesModal">
      <CRow class="mt-2">
        <CCol class="col-6">
          <label for="from-date">From Date</label>
          <b-form-datepicker id="from-date" v-model="fromDate"  class="mb-2"></b-form-datepicker>
        </CCol>
        <CCol class="col-6">
          <label for="end-date">End Date</label>
          <b-form-datepicker id="end-date" v-model="endDate" class="mb-2"></b-form-datepicker>
        </CCol>
      </CRow>
      <CRow class="mt-3">
        <CCol class="col-12">
          <label class="mb-2">Export Type:</label>
          <div>
            <b-button 
              @click="setExportType('order')" 
              :variant="export_type === 'order' ? 'primary' : 'outline-primary'" 
              class="mx-1"
            >
              Export: Order level
            </b-button>
            <b-button 
              @click="setExportType('order_item')" 
              :variant="export_type === 'order_item' ? 'primary' : 'outline-primary'" 
              class="mx-1"
            >
              Export: Item level
            </b-button>
            <b-button 
              @click="setExportType('roster')" 
              :variant="export_type === 'roster' ? 'primary' : 'outline-primary'" 
              class="mx-1"
            >
              Export: Roster level
            </b-button>
          </div>
        </CCol>
      </CRow>
      <template #modal-footer>
        <div class="w-100">
          <CRow class="mx-1">
            <b-button @click="setDateRange('this_week')" class="mt-2 mx-1" variant="primary">This week</b-button>
            <b-button @click="setDateRange('last_week')" class="mt-2 mx-1" variant="primary">Last week</b-button>
            <b-button @click="setDateRange('this_month')" class="mt-2 mx-1" variant="primary">This month</b-button>
            <b-button @click="setDateRange('last_month')" class="mt-2 mx-1" variant="primary">Last month</b-button>
            <b-button @click="setDateRange('this_quarter')" class="mt-2 mx-1" variant="primary">This quarter</b-button>
            <b-button @click="setDateRange('last_quarter')" class="mt-2 mx-1" variant="primary">Last quarter</b-button>
            <b-button @click="setDateRange('this_year')" class="mt-2 mx-1" variant="primary">This year</b-button>
          </CRow>
          <CRow class="mx-1 d-flex justify-content-between">
            <div>
              <b-button @click="setDateRange('last_year')" class="mt-2 mx-1" variant="primary">Last year</b-button>
              <b-button @click="setDateRange('all_time')" class="mt-2 mx-1" variant="primary">All time</b-button>
            </div>
            <div>
              <b-button @click="exportOrderPrices" class="mt-2 mx-1" variant="primary">Export</b-button>
              <b-button @click="closeExportOrderPricesModal" class="mt-2 mx-1" variant="secondary">Cancel</b-button>
            </div>
          </CRow>
        </div>
      </template>
    </b-modal>
    <b-modal no-close-on-backdrop ref="changeFactoryModal" id="change-factory" title="Select Factory" size="md" @hidden="onModalClose">



      <template v-if="change_factory_for_all">
        <strong>Select Factory:</strong>
        <v-select v-model="selectedFactory" :options="factories" id="change_factory" name="change_factory" placeholder="Select Factory" label="name"></v-select>
        <div class="mt-2">
          <strong>
            Select item status:
          </strong>
          <b-form-select v-model="selectedOrderStatus" :options="moveOrderOptions" placeholder="Select Updated Order Status"></b-form-select>
        </div>
      </template>
      <template v-else-if="order && !change_factory_for_all">
        <div :class="factory_product_index == 0 ? 'mt-1' : 'mt-5'"
             v-for="(factory_product, factory_product_index) in order.factory_products"
             :key="factory_product.id">
          <div>
            <strong>
              {{factory_product.is_new_product ? factory_product.new_product_name : factory_product.product_name}} - Move this product to:
              <template v-if="factory_product.reorder_data">
                {{`(Reorder from ${factory_product.reorder_data.order_number}: made at: ${factory_product.product_last_factory})`}}
              </template>
            </strong>
            <b-form-select v-model="factory_product.selected_factory_id" :options="factories" text-field="name"
                           value-field="id"/>
          </div>
          <div class="mt-2">
            <strong>
              Select item status:
            </strong>
            <b-form-select v-model="factory_product.selected_status" :options="moveOrderOptions" placeholder="Select Updated Order Status"></b-form-select>
          </div>
        </div>
      </template>
      <template v-if="show_all_items_option">
        <b-form-checkbox v-model="change_factory_for_all" class="mt-3">Apply to all items</b-form-checkbox>
      </template>
      <div v-if="!isFormValid" class="text-danger mt-2">
        {{ formValidationMessage }}
      </div>
      <template #modal-footer>
        <button
            class="btn btn-primary"
            @click="updateFactory()"
            :disabled="!isFormValid"
        >
          Save
        </button>
      </template>
    </b-modal>
    <template v-if="$can('upload-custom-techpack')">
      <b-modal ref="custom-techpack-modal" title="Custom Techpack" @hidden="custom_techpack_modal_order = null"
               @ok="uploadCustomTechpack">
        <template>
          <b-form-file ref="order-custom-tech-pack-input-ref" plain accept=".pdf" placeholder="Upload Custom Techpack"></b-form-file>
          <a v-if="custom_techpack_modal_order && custom_techpack_modal_order.techpack_data && custom_techpack_modal_order.techpack_data.length > 0"
             :href="`${storage_url}/${custom_techpack_modal_order.techpack_data[custom_techpack_modal_order.techpack_data.length -1 ].path}`"
             :key="`factory-await-${custom_techpack_modal_order.id}-custom-techpack`" target="_blank">
            Download Custom Techpack
          </a>
        </template>
      </b-modal>
    </template>
    <manual-order @order-created="handleOrderCreatedEvent" v-if="$can('manual-create-order')"  />
    <b-modal no-close-on-backdrop ref="assignOrderAdminModal" id="modal-6" @show="getOrderAdministratorUnassignedOrders" @hide="handleAssignOrderAdminModalHideEvent">
      <template #modal-title>Assign Order Admin</template>

      <strong>Select administrator:</strong>
      <v-select placeholder="Select Order Administrator" class="mb-3" v-model="selected_order_administrator" label="name" key="id" :options="order_administrators"></v-select>

      <strong>Select Orders to assign:</strong>
      <v-select placeholder="Select Orders" v-model="selected_order_administrator_orders" key="id" :options="order_administrator_unassigned_orders" multiple></v-select>
      <template #modal-footer>
        <b-button @click="$refs.assignOrderAdminModal.hide()" class="btn btn-secondary">Cancel</b-button>
        <b-button variant="primary" class="ml-2" @click="assignOrdersToOrderAdministrator">Assign Orders</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ManualOrder from "@/components/ManualOrder.vue";
import PaginationWithPerPage from '@/components/PaginationWithPerPage.vue';
import SearchItems from "@/components/SearchItems.vue";
import TechPackButtons from "@/components/TechpackButtons.vue";
import { http } from "@/config/httpCommon";
import {
  CustimooOrderFlowStatuses,
  getDateRange,
  getPageModal,
  getPaginationObject,
  handleResponseException,
  removePageModal,
  setPageModal
} from '@/helpers/Helpers';
import moment from 'moment';
import Key from 'vue-material-design-icons/Key.vue';
import Loading from 'vue-material-design-icons/Loading.vue';

const QUOTEREQUESTED = "quote_requested"
const QUOTEUPDATED = "quote_updated"
const QUOTEPROVIDED = "quote_provided"
const QUOTEREJECTED = "quote_rejected"
const FACTORYREVIEW = "submitted_for_factory_review"
const ORDERAPPROVE = "order_approve"
const ORDERCANCEL = "order_cancel"
const CUSTOMERREVIEW = "submitted_for_customer_review"
const CUSTOMERAPPROVED = "customer_approved"
const CUSTOMERREJECTED = "customer_rejected"
const ORDERINPRODUCTION = "in_production"
const ORDERSHIPPED = "shipped"
const ORDERCOMPLETED = "completed"

export default {
  name: 'NewDashboard',
  components: {
    SearchItems,
    Loading,
    Key,
    PaginationWithPerPage,
    ManualOrder,
    TechPackButtons
  },
  computed: {
    company_name() {
      let user = JSON.parse(localStorage.getItem('user'))
      let company = ''
      if (user && user.store) {
        company = user.store
      }
      return company
    },
    areStatusesConsistentForSameFactory() {
      if (!this.order || !this.order.factory_products) return true;

      const factoryStatusMap = new Map();

      for (const product of this.order.factory_products) {
        const factoryId = product.selected_factory_id;
        const status = product.selected_status;

        if (factoryId === null || status === null) continue;

        if (factoryStatusMap.has(factoryId)) {
          if (factoryStatusMap.get(factoryId) !== status) {
            return false; // Inconsistent status found
          }
        } else {
          factoryStatusMap.set(factoryId, status);
        }
      }

      return true;
    },
    isFormValid() {
      return this.areStatusesConsistentForSameFactory;
    },

    formValidationMessage() {
      if (this.isFormValid) return '';
      return 'Products assigned to the same factory must have the same status.';
    },
    isSuperOrOrderAdmin() {
      const role = this.role_name.toLowerCase();
      // Return true if the user is either "orderadministrator" or "superadmin"
      return role === 'orderadministrator' || role === 'superadmin';
    },
    filteredOrderAdminsMap() {
      const factoryIds = this.selected_factory_ids;
      return this.order_administrators.filter(admin => {
          const formattedRoleNames = admin.role_names?.map(role => 
            role.replace(/\s+/g, '')
          );
          // If admin has "Lead Order Administrator" role, skip factory ID checking
          if (formattedRoleNames?.some(role => role.toLowerCase() === 'leadorderadministrator')) {
            return true;
          }
          // Otherwise, check factory IDs
          return admin.factory_ids && admin.factory_ids.some(fid => factoryIds.includes(fid));
      });
    },
  },
  data () {
    const today = new Date();
    // Construct the first day of the month explicitly in "YYYY-MM-DD" format
    const firstDayOfMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-01`;
    const endDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    return {
      fromDate: firstDayOfMonth,
      endDate: endDate,
      export_type: 'order',
      isLoading: false,
      completed_items_count:0,
      customer_await_items_count:0,
      quote_requested_items_count:0,
      pending_for_factory_assignment_count:0,
      pending_items_count:0,
      urgent_action_items_count:0,
      all_items_count:0,
      shipping_in_week_count:0,
      reorders_count: 0,
      unresolved_comments_count: 0,
      pending_merchant_approval_items_count: 0,
      storage_url:process.env.VUE_APP_FILE_URL,
      app_environment:process.env.NODE_ENV,
      selectedFactory: {},
      selectedOrderId: null,
      order: null,
      change_factory_for_all: false,
      show_all_items_option: true,
      params:{
        search:"",
        sortBy:"order_no",
        sortOrder:"desc",
        optional:null,
        order_administrator_id: null
      },
      current_Tab:"all_items",
      selected: 'Month',
      order_items_by_status_group:[],
      selected_factory_ids:[],
      status_count:{
        completed_items_count:0,
        created_items_count:0,
        production_items_count:0,
        shipped_items_count:0,
        shareable_items_count:0
      },
      pending_for_factory_assignment:{
        data:[]
      },
      urgent_action_items:{
        data:[]
      },
      customer_await_items:{
        data:[]
      },
      quote_requested_items:{
        data:[]
      },
      pending_items:{
        data:[]
      },
      completed_items:{
        data:[]
      },
      all_items:{
      },
      pagination_object:{
      },
      reorders: {
        data: []
      },
      unresolved_comments: {
        data: []
      },
      pending_merchant_approval_items: {
        data: []
      },
      orders: [],
      role:{},
      factories: [],
      quote : {
        quote_text :'',
        quote_order_id:'',
        quote_order_no:''
      },
      product_price_breakdown: [],
      order_price_list_detail: 0,
      QUOTEREQUESTED : QUOTEREQUESTED,
      QUOTEUPDATED : QUOTEUPDATED,
      QUOTEPROVIDED : QUOTEPROVIDED,
      QUOTEREJECTED : QUOTEREJECTED,
      FACTORYREVIEW : FACTORYREVIEW,
      ORDERAPPROVE : ORDERAPPROVE,
      ORDERCANCEL : ORDERCANCEL,
      CUSTOMERREVIEW : CUSTOMERREVIEW,
      CUSTOMERAPPROVED : CUSTOMERAPPROVED,
      CUSTOMERREJECTED : CUSTOMERREJECTED,
      ORDERINPRODUCTION : ORDERINPRODUCTION,
      ORDERSHIPPED : ORDERSHIPPED,
      ORDERCOMPLETED : ORDERCOMPLETED,
      PRODUCTIONFILESUPLOADED : ORDERINPRODUCTION,
      moveOrderOptions : [
        { value: null, text: 'Please select an option' },
        { value: FACTORYREVIEW , text: 'Order Created' },
        { value: ORDERAPPROVE , text: 'Mark to factory' },
        { value: ORDERCANCEL , text: 'Order Cancelled' },
        { value: CUSTOMERREVIEW, text: 'Customer Review' },
        { value: ORDERINPRODUCTION, text: 'In Production' },
        { value: ORDERSHIPPED, text: 'Order Shipped' },
        { value: ORDERCOMPLETED, text: 'Order Completed' }
      ],
      selectedOrderStatus: null,
      products: [],
      custom_techpack_modal_order: null,
      order_administrators: [],
      order_administrator_unassigned_orders: [],
      selected_order_administrator: null,
      selected_order_administrator_orders: []
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('Do MMM YYYY');
    },
    ago: function(date){
      return moment(date).fromNow()
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    status: function(value){
      if (value) {
        return CustimooOrderFlowStatuses[value];
      }
    },
    shippingAddress : function (shipping_address) {
      if(!shipping_address){
        return '';
      }else{
        return  `${shipping_address.address1 || ''} ${shipping_address.address2 || ''} ${shipping_address.city || ''}
        ${shipping_address.zip_code || ''} ${shipping_address.country || ''}`
      }
    }
  },
  async created(){
    this.isLoading = true;
    this.getFactories()
    this.pagination_object = getPaginationObject()
    this.role = localStorage.getItem('role')?JSON.parse(localStorage.getItem('role')): null;
    await this.fetchData();
    if (this.$can('assign-order-administrator')) {
      this.getOrderAdministrators()
    } else {
      if (this.role_name.toLowerCase() === 'orderadministrator') {
        this.order_administrators = [{id: this.auth_user.id, name: this.auth_user.name}]
      }
    }
  },
  methods: {
    getPaginationObject,
    async deleteOrder(orderID){
      let confirmDelete = confirm('Are you sure that you want to delete this order?');

      if(confirmDelete) {
        try {
          this.isLoading = true;
          this.$store.commit('set', ['showLoader', true]);
          await http.delete(`order/delete/${orderID}`).then(async response => {
            if (response.data.success && response.data.status_code === 200) {
              this.showToast(response.data.message, 'SUCCESS');
              let product_modal = getPageModal();
              let page = null;
              let item_for = null;
              if(product_modal && product_modal.page && product_modal.page_name === this.$route.name) {
                if (product_modal.search.sortBy && product_modal.search.sortOrder && !product_modal.search.search) {
                  page = product_modal.page;
                  item_for = product_modal.tab;
                  this.current_Tab = product_modal.tab;
                  this.params.search = "";
                  this.params.sortBy = product_modal.search.sortBy;
                  this.params.sortOrder = product_modal.search.sortOrder;
                  this.params.optional = product_modal.search.optional;
                } else if (product_modal.search.search) {
                  page = 1;
                  item_for = product_modal.tab;
                  this.current_Tab = product_modal.tab;
                  this.params.search = "";
                  this.params.sortBy = product_modal.search.sortBy;
                  this.params.sortOrder = product_modal.search.sortOrder;
                  this.params.optional = product_modal.search.optional;
                } else {
                  page = product_modal.page;
                  item_for = product_modal.tab;
                  this.current_Tab = product_modal.tab;
                  this.params.sortBy = product_modal.search.sortBy;
                  this.params.sortOrder = product_modal.search.sortOrder;
                  this.params.optional = product_modal.search.optional;
                  // payload = `?page=${product_modal.page}&name=&`;
                }
                await this.getDashboardData(page, item_for)
              }

              this.isLoading = false;
              this.$store.commit('set', ['showLoader', false]);
            } else {
              this.isLoading = false;
              this.$store.commit('set', ['showLoader', false]);
            }
          });
        } catch (e) {
          console.log(e);
          this.isLoading = false
        }
      }
    },
    async getDashboardData(page=null,items_for=null){
      try{
        this.isLoading = true;
        this.$store.commit('set', ['showLoader', true]);
        setPageModal(page,this.$route.name,this.params,items_for, this.pagination_object.per_page);
        let query_params = `items_for=${items_for}${'&sort_by='+ this.params.sortBy}${'&sort_order='+ this.params.sortOrder}${page?`&page=${page}`:''}`
        query_params += `&search=${this.params.search}&per_page=${this.pagination_object.per_page}`
        if(this.params.order_administrator_id) {
          query_params += `&order_administrator_id=${this.params.order_administrator_id.id}`
        }
        await http.get(`dashboard?${query_params}`).then(response => {
          if(response.data.success && response.data.status_code === 200){
            this.order_items_by_status_group = response.data.result.order_items_by_status_group
            this[this.current_Tab] = response.data.result.items
            this.pagination_object = getPaginationObject(this[this.current_Tab])
              let {completed_items_count, customer_await_items_count, quote_requested_items_count, pending_for_factory_assignment_count, pending_items_count, urgent_action_items_count, all_items_count,shipping_in_week_count, reorders_count, unresolved_comments_count, pending_merchant_approval_items_count } = response.data.result.tab_count
            this.completed_items_count = completed_items_count;
            this.customer_await_items_count = customer_await_items_count;
            this.quote_requested_items_count = quote_requested_items_count;
            this.pending_for_factory_assignment_count = pending_for_factory_assignment_count;
            this.pending_items_count = pending_items_count;
            this.urgent_action_items_count = urgent_action_items_count;
            this.all_items_count = all_items_count;
            this.shipping_in_week_count = shipping_in_week_count
            this.reorders_count = reorders_count;
            this.unresolved_comments_count = unresolved_comments_count;
            this.pending_merchant_approval_items_count = pending_merchant_approval_items_count;
            this.$store.commit('set', ['showLoader', false]);
            this.isLoading = false;
          }else{
            this.$store.commit('set', ['showLoader', false]);
            this.isLoading = false;
          }
        });
      }
      catch(e){
        console.log(e);
        this.isLoading = false
      }
    },
    async handlePagination(page= '', items_for){
      try{
        this.isLoading = true;
        this.$store.commit('set', ['showLoader', true]);
        setPageModal(page,this.$route.name,this.params,items_for);
        if(this.current_Tab !== 'all_items'){
          let query_params = `items_for=${items_for}${'&sort_by='+ this.params.sortBy}${'&sort_order='+ this.params.sortOrder}${page?`&page=${page}`:''}`
          query_params += `&search=${this.params.search}&per_page=${this.pagination_object.per_page}`
          if(this.params.order_administrator_id) {
            query_params += `&order_administrator_id=${this.params.order_administrator_id.id}`
          }
          await http.get(`dashboard/items?${query_params}`).then(response => {
            if(response.data.success){
              this[items_for] = response.data.result.items
              this.pagination_object = getPaginationObject(this[this.current_Tab])
              // this.orders = response.data.result.orders;
              this.$store.commit('set', ['showLoader', false]);
              this.isLoading = false;
            }else{
              this.$store.commit('set', ['showLoader', false]);
              this.isLoading = false
            }
          });
        }
        else{
          this.getDashboardData(page,items_for);
        }

      }
      catch(e){
        console.log(e);
        this.$store.commit('set', ['showLoader', false]);
        this.isLoading = false
      }

    },
    async searchOrders(){
      this.getDashboardData(1,this.current_Tab)
    },
    uploadDesign(user){
      console.log(user);
    },
    message(user){
      console.log(user);
    },
    switchOrdersTab(tab){
      this.current_Tab = tab;
      this.params.sortBy = 'order_no';
      this.params.sortOrder = this.params.sortOrder ?? 'desc'
      this.params.optional = null;
      this.getDashboardData(1,tab);
    },
    sortOrders(tab,column,optional = null){
      this.params.sortBy = column;
      this.params.sortOrder = this.params.sortOrder === 'asc'? 'desc': 'asc';
      this.params.optional = optional;
      this.current_Tab = tab;
      this.getDashboardData(1,tab);
    },
    getFactories() {
      http.get('dashboard-factories').then(successResponse => {
        this.factories = [{id: null, name: "Select factory"}, ...successResponse.data.data]
      })
    },
    validateFactoryAssignmentData(order_item) {
      if(order_item.factory_products.every(product => product.selected_factory_id !== null)) {
        const is_multiple_factories_assigned = this.isMultipleFactoriesAssignedToSameProduct(order_item)
        if(is_multiple_factories_assigned) {
          this.$fire({
            title: "Are you sure!",
            text: "You are assigning different factories to same product",
            type: "info",
            showCancelButton: true,
          }).then(response => {
            if(response.value) {
              this.updateOrderAdmin(order_item);
              this.assignFactory(order_item)
            }
          });
        } else {
          this.updateOrderAdmin(order_item);
          this.assignFactory(order_item)
        }
      } else {
        this.showToast("Please select factory for all products in this order item.",'error');
      }
    },
    cancelAssignFactory(order_item) {
      this.selected_factory_ids = [];
      order_item.editing = false
    },
    assignFactory(order_item) {
      const product_factory_ids = order_item.factory_products.reduce((object, {id, selected_factory_id}) => {
        object[id] = selected_factory_id;
        return object;
      }, {});
      const payload = {
        order_item_id: order_item.id, order_id: order_item.order_id, product_factory_ids
      };
      http.post(`/assign_factory`, payload).then(response => {
        let message_type = 'SUCCESS'
        if (response.data.success) {
          order_item.editing = false
          this.getDashboardData(null, 'pending_for_factory_assignment')
        } else {
          message_type = 'ERROR'
        }
        order_item.updating = false
        this.selected_factory_ids = [];
        this.showToast(response.data.message, message_type);
      }).catch(e => {
        order_item.updating = false
        this.selected_factory_ids = [];
        this.showError(e.response.data.message)
      });
    },
    async fetchData() {
      this.$store.commit('set', ['showLoader', true]);
      let product_modal = getPageModal();
      let page = null;
      let item_for = null;
      if(product_modal && product_modal.page && product_modal.page_name === this.$route.name){
        if(product_modal.search.sortBy && product_modal.search.sortOrder){
          page = product_modal.page ;
          item_for = product_modal.tab;
          this.current_Tab = product_modal.tab;
          this.params.search = product_modal.search.search;
          this.params.sortBy = product_modal.search.sortBy;
          this.params.sortOrder = product_modal.search.sortOrder;
          this.params.optional = product_modal.search.optional;
          this.params.order_administrator_id = product_modal.search.order_administrator_id;
        }
        else{
          page = product_modal.page;
          item_for = product_modal.tab;
          this.current_Tab = product_modal.tab;
          this.params.sortBy = product_modal.search.sortBy;
          this.params.sortOrder = product_modal.search.sortOrder;
          this.params.order_administrator_id = product_modal.search.order_administrator_id;
          // payload = `?page=${product_modal.page}&name=&`;
        }
        await this.getDashboardData(page,item_for)
      }
      else{
        removePageModal();
        await this.getDashboardData(1,this.current_Tab);
      }
      this.$store.commit('set', ['showLoader', false]);
    },
    isMultipleFactoriesAssignedToSameProduct(order_item) {
      const factory_products = order_item.factory_products;
      let is_multiple_factories_assigned_to_same_product = false;
      let products_factory_info = {}
      factory_products.forEach(factory_product => {
        if(products_factory_info[factory_product.product_id]) {
          products_factory_info[factory_product.product_id].push(factory_product.selected_factory_id)
        } else {
          products_factory_info[factory_product.product_id] = [factory_product.selected_factory_id]
        }
      })
      Object.values(products_factory_info).some(products_factory_info_item => {
        if(new Set(products_factory_info_item).size !== 1) {
          is_multiple_factories_assigned_to_same_product = true;
          return true;
        }
      })
      return is_multiple_factories_assigned_to_same_product;
    },
  async  showFactoriesDropdown(order_item) {
      const orderData = await this.$store.dispatch('getFactoryProducts', { order_id: order_item.order_id, order_item_id: order_item.id });
      const factoryProducts = orderData.items?.[0]?.factory_products ?? [];
      this.$set(order_item, 'factory_products', factoryProducts);
      order_item.editing = true;
      order_item.factory_products.forEach(item => item.selected_factory_id = null)
    },
    showDashboardCard(card_name) {
      if(this.$can('show-dashboard-card')) {
        return true
      } else {
        return card_name != "Shareable"
      }
    },
    loginCustomer(customer_id){
      http.get(`customer/information/${customer_id}`).then((res) =>{
        let token = res.data.access_token
        if (res.data.user.company_url){
          const url = res.data.user.company_url+'/#/'
          window.open(`${url}admin/login?token=${token}`);
        }
      }).catch(err =>{
        console.log(err)
      })
    },
    provideQuotePrice(order) {
      this.quote.quote_order_id = order.id;
      this.quote.quote_order_no = order.order_no;
      this.quote.quote_text = '';
      this.$refs.quoteAcceptModal.show();
    },
    notifyCustomerForQuote(order_id) {
      this.$store.commit('set', ['showLoader', true]);
      http.get(`/notify-customer-quote/${order_id}`,).then(async response => {
        this.$store.commit('set', ['showLoader', false]);
        let message_type = 'SUCCESS'
        if (response.data.message) {
          this.showToast("Email has been sent to customer.", message_type);
        }
      }).catch(e => {
        this.$store.commit('set', ['showLoader', false]);
        this.showError(e.response.data.message)
      });
    },
    saveQuotePrice() {

      if(this.quote.quote_text == '') {
        this.showToast('please provide quote text.', 'ERROR');
        return false;
      }
      this.$store.commit('set', ['showLoader', true]);
      http.post(`/save-quote-price`, this.quote).then(async response => {
        let message_type = 'SUCCESS'
        this.$store.commit('set', ['showLoader', false]);
        if (response.data.success) {
          this.quote.quote_order_id = '';
          this.quote.quote_order_no = '';
          this.quote.quote_text = '';
          this.$refs.quoteAcceptModal.hide();
          let page = null;
          let product_modal = getPageModal();
          if (product_modal && product_modal.page) {
            page = product_modal.page;
            await this.getDashboardData(page, 'quote_requested_items')
          } else {
            message_type = 'ERROR'
          }
          this.showToast(response.data.message, message_type);
        }
      }).catch(e => {
        this.$store.commit('set', ['showLoader', false]);
        this.showError(e.response.data.message)
      });

    },
    showPriceBreakdown(order) {
      let addonsNetTotal = 0;
      if (order.techpack_data) {
        this.product_price_breakdown = order.factory_products.map((product) => {
          const groupedAddons = Object.values(product.grouped_addons || []);
          const ungroupedAddons = product.ungrouped_addons || [];
          const totalQuantity = product.product_roster_detail.reduce((sum, roster) => {
            return sum + (Number(roster.quantity) || 0);
          }, 0);
          return {
            name: product.product_name,
            price_detail: product.price_list_detail,
            addons: product.addons?.map((addon) => {
              return {
                name: addon.title,
                price_detail: addon.price_list_detail ?? null,
                subTotal: addon.price_list_detail ? addon.price_list_detail.subtotal : 0,
              }
            }),
            groupedAddons: groupedAddons.map((grouped_addon) => {
              addonsNetTotal += grouped_addon.skucurrency[0].pivot.net_price ? grouped_addon.skucurrency[0].pivot.net_price * product.product_price_object.quantity : 0;
              return {
                name: grouped_addon.sku_id,
                net_price: grouped_addon.skucurrency.pivot.net_price ?? 0
              }
            }),
            ungroupedAddons: ungroupedAddons.map((ungrouped_addon) => {
              addonsNetTotal += ungrouped_addon.skucurrency[0].pivot.net_price ? ungrouped_addon.skucurrency[0].pivot.net_price * product.product_price_object.quantity : 0;
              return {
                name: ungrouped_addon.sku_id,
                net_price: ungrouped_addon.skucurrency.pivot.net_price ?? 0
              }
            }),
            subTotal: product.price_list_detail.net_price * totalQuantity,
            quantity: totalQuantity,
            img_url: product.front_image,
            sku_number: product.sku_number
          }
        })
      } else {
        this.product_price_breakdown = order.factory_products.map((product) => {
          const groupedAddons = Object.values(product.grouped_addons || []);
          const ungroupedAddons = product.ungrouped_addons || [];
          return {
            name: product.product_name,
            price_detail: product.price_list_detail,
            addons: product.addons?.map((addon) => {
              return {
                name: addon.title,
                price_detail: addon.price_list_detail,
                subTotal: addon.price_list_detail.subtotal
              }
            }),
            groupedAddons: groupedAddons.map((grouped_addon) => {
              addonsNetTotal += grouped_addon.skucurrency[0].pivot.net_price ? grouped_addon.skucurrency[0].pivot.net_price * product.product_price_object.quantity : 0;
              return {
                name: grouped_addon.sku_id,
                net_price: grouped_addon.skucurrency[0].pivot.net_price ?? 0
              }
            }),
            ungroupedAddons: ungroupedAddons.map((ungrouped_addon) => {
              addonsNetTotal += ungrouped_addon.skucurrency[0].pivot.net_price ? ungrouped_addon.skucurrency[0].pivot.net_price * product.product_price_object.quantity : 0;
              return {
                name: ungrouped_addon.sku_id,
                net_price: ungrouped_addon.skucurrency[0].pivot.net_price ?? 0,
              }
            }),
            subTotal: product.price_list_detail.subtotal,
            quantity: product.product_price_object.quantity,
            img_url: product.front_image,
            sku_number: product.sku_number
          }
        })
      }
      this.order_price_list_detail = { ...order.price_list_detail };
      this.order_price_list_detail.item_net_total += addonsNetTotal;
      this.$refs.priceBreakdownModal.show();
    },
    formatPrice(price) {
      return Number(price).toFixed(2);
    },
    openOrderPriceModal(){
      this.$refs.exportOrderPriceModal.show();
    },
    async exportOrderPrices(){
      this.$store.commit('set', ['showLoader', true]);
      try {
        let product_modal = getPageModal();
        let item_for = null;
        if(product_modal && product_modal.page && product_modal.page_name === this.$route.name) {
            if (product_modal.search.sortBy && product_modal.search.sortOrder && !product_modal.search.search) {
                item_for = product_modal.tab;
                this.current_Tab = product_modal.tab;
                this.params.search = product_modal.search.search;
                this.params.sortBy = product_modal.search.sortBy;
                this.params.sortOrder = product_modal.search.sortOrder;
                this.params.optional = product_modal.search.optional;
            } else if (product_modal.search.search) {
                item_for = product_modal.tab;
                this.current_Tab = product_modal.tab;
                this.params.search = product_modal.search.search;
                this.params.sortBy = product_modal.search.sortBy;
                this.params.sortOrder = product_modal.search.sortOrder;
                this.params.optional = product_modal.search.optional;
            } else {
                item_for = product_modal.tab;
                this.current_Tab = product_modal.tab;
                this.params.sortBy = product_modal.search.sortBy;
                this.params.sortOrder = product_modal.search.sortOrder;
                this.params.optional = product_modal.search.optional;
                this.params.search = product_modal.search.search;
                  // payload = `?page=${product_modal.page}&name=&`;
          }
        }  
        let response = null;
        if(this.current_Tab !== 'all_items'){
          let query_params = `items_for=${item_for}${'&sort_by='+ this.params.sortBy}${'&sort_order='+ this.params.sortOrder}`
          query_params += `&search=${this.params.search}`
          if(this.params.order_administrator_id) {
            query_params += `&order_administrator_id=${this.params.order_administrator_id.id}`
          } 
          response = await http.post(`/export-order-prices?${query_params}`, {
            from_date: this.fromDate,
            end_date: this.endDate,
            item_for: this.item_for,
            export_type: this.export_type,
          }, {
            responseType: 'blob'
          });
        }
        else {
          response = await http.post(`/export-order-prices`, {
            from_date: this.fromDate,
            end_date: this.endDate,
            item_for: this.item_for,
            export_type: this.export_type,
          }, {
            responseType: 'blob'
          });
        }   

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const fileName = `${this.export_type}_prices.xlsx`;
        console.log('Export type:', this.export_type, 'Filename:', fileName);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$store.commit('set', ['showLoader', false]);

      } catch (error) {
        this.$store.commit('set', ['showLoader', false]);
        console.error('Error downloading the file:', error);
      }
    },
    closeExportOrderPricesModal(){
      // Reset start and end dates to default values
      const today = new Date();
      // Construct the first day of the month explicitly in "YYYY-MM-DD" format
      const firstDayOfMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-01`;
      const endDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      this.fromDate = firstDayOfMonth;
      this.endDate = endDate;
      this.export_type = 'order_item';

      this.$refs.exportOrderPriceModal.hide();
    },
    async showUpdateFactoryModal(item) {

      let factory = this.factories.find((factory) => item.factory_id === factory.id);
      this.order = {
    ...JSON.parse(JSON.stringify(item)),
    factory_products: []
  };
      const orderData = await this.$store.dispatch('getFactoryProducts', { order_id: item.order_id, order_item_id: item.id });
      let factoryProducts = orderData.items?.[0]?.factory_products ?? [];
      // factoryProducts = factoryProducts.filter(factoryProduct => {
      //   if(factoryProduct.shop_id && !factoryProduct.is_produced_by_custimoo && factoryProduct.is_custom_product) {
      //     return false
      //   } else {
      //     return true
      //   }
      // })
      

      this.$set(this.order, 'factory_products', factoryProducts.map(product => ({
        ...product,
        selected_factory_id: product.factory_id,
        selected_status: null
      })));
      this.$set(item, 'factory_products', factoryProducts);
      this.selectedOrderId = item.order_id;
      this.selectedFactory = factory;
      if(item.factory_products.length === 1){
        this.show_all_items_option = false;
      }
      // setTimeout(() => {
       
        this.$refs.changeFactoryModal.show();
      // }, 5000);
     
    },
    updateFactory() {
      this.$store.commit('set', ['showLoader', true]);
      let payload = {
        order_id: this.selectedOrderId,
        order_item_id: this.order.id,
        product_factory_ids: {},
      };

      if (this.change_factory_for_all) {
        this.order.factory_products.forEach(product => {
          payload.product_factory_ids[product.id] = {
            factory_id: this.selectedFactory.id,
            order_status: this.selectedOrderStatus
          };
        });
      } else {
        this.order.factory_products.forEach(product => {
          payload.product_factory_ids[product.id] = {
            factory_id: product.selected_factory_id,
            order_status: product.selected_status
          };
        });
      }
      const validationCheckForFactoryProductWithStatus = this.validateFactoryProductWithStatus(payload);
      if(!validationCheckForFactoryProductWithStatus.valid){
        this.showToast(validationCheckForFactoryProductWithStatus.message, 'ERROR');
        this.$store.commit('set', ['showLoader', false]);
        return;
      }

      try {
        this.$store.dispatch('updateOrderFactory', payload).then(async (res) => {
          if (res) {
            this.$store.commit('set', ['showLoader', false]);
            await this.fetchData();
            this.$refs.changeFactoryModal.hide();
            this.showToast(res.data.message, 'SUCCESS');
            this.selectedFactory = {};
            this.change_factory_for_all = false;
          }
        });
      } catch (e) {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast('Error updating factory', 'ERROR');
        this.$refs.changeFactoryModal.hide();
        this.selectedFactory = {};
        this.change_factory_for_all = false;
      }
    },
    onModalClose(){
      this.show_all_items_option = true;
    },
    validateFactoryProductWithStatus(payload) {
      const productFactoryIds = payload.product_factory_ids;
      const factoryStatusMap = {};

      for (const productId in productFactoryIds) {
        const { factory_id, order_status } = productFactoryIds[productId];

        // Check if factory_id or order_status is null
        if (factory_id == null) {
          const {product_name} = this.order.factory_products.find(factory_product => factory_product.id === productId);
          return { valid: false, message: `Factory is not selected for product ${product_name}.` };
        }

        if (order_status == null) {
          const {product_name} = this.order.factory_products.find(factory_product => factory_product.id === productId);
          return { valid: false, message: `Order Status is not selected for product ID ${product_name}.` };
        }

        // Ensure the same factory_id has consistent order_status
        if (factoryStatusMap[factory_id]) {
          if (factoryStatusMap[factory_id] !== order_status) {
            const {name} = this.factories.find((factory) => factory.id === factory_id);
            return {
              valid: false,
              message: `Order status for same factory ${name} should be same.`
            };
          }
        } else {
          factoryStatusMap[factory_id] = order_status;
        }
      }

      return { valid: true, message: "Validation passed." };

    },
    uploadCustomTechpack(event) {
      event.preventDefault()
      const custom_tech_pack_file_input_files = this.$refs['order-custom-tech-pack-input-ref'].files
      if(custom_tech_pack_file_input_files.length > 0) {
        const order = this.custom_techpack_modal_order
        const custom_techpack_file = custom_tech_pack_file_input_files[0]
        const form_data = new FormData();
        form_data.append("custom_techpack_pdf", custom_techpack_file)
        form_data.append("order_id", order.id)
        this.$store.commit('set', ['showLoader', true]);
        http.post("updload-custom-techpack", form_data).then(successResponse => {
          this.$store.commit('set', ['showLoader', false]);
          order.techpack_data = successResponse.data.result.techpack_data
          this.$refs['custom-techpack-modal'].hide()
          this.showToast(successResponse.data.message, "SUCCESS");
          this.custom_techpack_modal_order = null
        }).catch(errorResponse => {
          this.$store.commit('set', ['showLoader', false]);
          handleResponseException(errorResponse)
        })
      } else {
        setTimeout(() => {
          this.$refs['custom-techpack-modal'].hide()
        })
      }
    },
    showCustomTechPackModal(order) {
      this.custom_techpack_modal_order = order
      this.$refs['custom-techpack-modal'].show()
    },
    handleOrderCreatedEvent() {
      const page_modal = getPageModal(this.$route.name)
      if(page_modal) {
        this.getDashboardData(page_modal.page, this.current_Tab)
      } else {
        this.getDashboardData(null, this.current_Tab)
      }
    },
    showAssignOrderAdminModal() {
      this.$refs.assignOrderAdminModal.show();
    },
    getOrderAdministrators() {
      http.get("role/users?role[]=orderAdministrator&role[]=leadOrderAdministrator").then(successResponse => {
        this.order_administrators = successResponse.data.result.users
      }).catch(e => {
        this.showError(e.response.data.message)
      });
    },
    getOrderAdministratorUnassignedOrders() {
      this.$store.commit('set', ['showLoader', true]);
      http.get("get_order_administrator_unassinged_orders").then(successResponse => {
        this.$store.commit('set', ['showLoader', false]);
        this.order_administrator_unassigned_orders = successResponse.data.result.orders
      }).catch(e => {
        this.$store.commit('set', ['showLoader', false]);
        this.showError(e.response.data.message)
      });
    },
    handleAssignOrderAdminModalHideEvent() {
      this.selected_order_administrator = null
      this.selected_order_administrator_orders = []
    },
    assignOrdersToOrderAdministrator() {
      this.$store.commit('set', ['showLoader', true]);
      const payload = {
        user_id: this.selected_order_administrator.id,
        order_ids: this.selected_order_administrator_orders.map(selected_order_administrator_order => {
          return selected_order_administrator_order.id
        })
      }
      http.post("assign_order_to", payload).then(successResponse => {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast("Order admin assigned", "SUCCESS");
        this.$refs.assignOrderAdminModal.hide();
      }).catch(e => {
        this.$store.commit('set', ['showLoader', false]);
        this.showError(e.response.data.message)
        this.$refs.assignOrderAdminModal.hide();
      });
    },
    async fetchAndOpenPdf(order, version_id) {
      try {
        let order_id = order.id
        let techpack_data_length = order.techpack_data ? order.techpack_data.length : 0;
        // if(version_id === 0) {
        //   version_id = version_id
        // } else {
        //   version_id = version_id;
        // }

        // Fetch the URL from the Laravel API
        this.$store.commit('set', ['showLoader', true]);
        const response = await http.get(`techpackpdf/order/${order_id}/version/${version_id}`);
        this.$store.commit('set', ['showLoader', false]);
        const pdfUrl = response.data.result.pdf_url;
        if(pdfUrl){
          window.open(`${this.storage_url}/${pdfUrl}`, '_blank');
        }
        else {
          if (techpack_data_length) {
            window.open(`order/${order_id}/condensend-pdf?techpack_version=${version_id}`, '_blank')
          } else {
            window.open(`order/${order_id}/condensend-pdf`, '_blank')
          }
        }
      } catch (error) {
        console.error('Error fetching the PDF URL:', error);
      }
    },
    async openAWSFileFromOrder(order){
      try{      
        let order_id = order.id

        // Fetch the URL from the Laravel API
        this.$store.commit('set', ['showLoader', true]);
        const response = await http.get(`designfile/order/${order_id}`);
        this.$store.commit('set', ['showLoader', false]);
        const url = response.data.result.url;
        // Open the URL in a new tab
        if(url){
          window.open(`${url}`, '_blank');
        }
      } catch (error) {
        console.error('Error fetching the PDF URL:', error);
      }
    },
    updateOrderAdmin(item) {
      this.$store.commit('set', ['showLoader', true]);
      const payload = {
        user_id: item.order.order_administrator_id,
        order_ids: item.order.id
      }
      http.post("assign_order_to", payload).then(successResponse => {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast("Order admin updated", "SUCCESS");
        if(item.order.order_administrator_id == null) {
          this.fetchData();
        }
        this.$refs.assignOrderAdminModal.hide();
      }).catch(e => {
        this.$store.commit('set', ['showLoader', false]);
        this.showError(e.response.data.message)
        this.$refs.assignOrderAdminModal.hide();
      });
    },
    setDateRange(option) {
      try {
        if (option === 'all_time') {
          // Clear the dates for "All Time"
          this.fromDate = null;
          this.endDate = null;
        } else {
          const { from, to } = getDateRange(option);

          // Format dates to "YYYY-MM-DD"
          this.fromDate = from.toISOString().split('T')[0]; // Extract only the date
          this.endDate = to.toISOString().split('T')[0];   // Extract only the date
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    setExportType(type) {
      this.export_type = type;
    },
    getOrderAdminsbyFactoryId(order_item){
      
      return this.order_administrators.filter((admin)=> {
        const formattedRoleNames = admin.role_names?.map(role => 
            role.replace(/\s+/g, '')
          );
        // If admin has "Lead Order Administrator" role, skip factory ID checking
        if (formattedRoleNames?.some(role => role.toLowerCase() === 'leadorderadministrator')) {
            return true;
        }
        return admin.factory_ids && admin.factory_ids.filter(fid => fid === order_item.factory_id);
      })
    },
    handleFactoryChange(event , index ){
      this.selected_factory_ids[index] = event;
    },
  }
}
</script>
<style lang="scss" scoped>
table.urgent_action_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.urgent_action_items td, table.urgent_action_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.urgent_action_items tr:nth-child(even){background-color: #f2f2f2;}

table.urgent_action_items tr:hover {background-color: #ddd;}

table.urgent_action_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #fa1313;
  color: white;
}

table.pending_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.pending_items td, table.pending_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.pending_items tr:nth-child(even){background-color: #f2f2f2;}

table.pending_items tr:hover {background-color: #ddd;}

table.pending_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #424242;
  color: white;
}
table.customer_await_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.customer_await_items td, table.customer_await_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.customer_await_items tr:nth-child(even){background-color: #f2f2f2;}

table.customer_await_items tr:hover {background-color: #ddd;}

table.customer_await_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #04AA6D;
  color: white;
}

table.all_items{
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table.all_items td, table.all_items th {
  border: 1px solid #ddd;
  padding: 8px;
}

table.all_items tr:nth-child(even){background-color: #f2f2f2;}

table.all_items tr:hover {background-color: #ddd;}

table.all_items th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #200370;
  color: white;
}

.dropdown_btn{
  display: inline-flex;
  border-left: 1px solid #ccc;
  align-items: center;
  justify-content: center;
  padding: 10px 0 10px 10px;
  cursor: pointer;
}
.assign_factory{
  position: absolute;
  background-color: white;
  box-shadow: 0 0 10px rgba(0,0,0,0.2), 0 0 0 10000px rgba(0,0,0,0.25);
  padding: 10px;
  border-radius: 5px;
  right: 0;
  z-index: 100;
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>
